<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    size="lg"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    no-close-on-backdrop
    v-model="showModal"
    :ok-disabled="form.errors.any()"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <b-container fluid class="p-0">
        <b-row v-if="isFornecedorFieldLocked">
          <b-col>
            <b-alert show variant="warning" class="mb-2">
              {{ fornecedorBannerMessage }}
              <a
                v-if="urlPlataformaLogistica"
                :href="urlPlataformaLogistica"
                target="_blank"
                rel="noopener noreferrer"
              >
                Acesse aqui
              </a>
            </b-alert>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h5 class="with-border">
              <b-badge variant="secondary">Tipo Cliente</b-badge>
            </h5>
          </b-col>
        </b-row>
        <b-row no-gutters>
          <div>
            <b-form-radio-group
              label-size="lg"
              v-model="form.tipo_pessoa"
              class="clearfix"
            >
              <b-form-radio
                @input="ajustaMascara()"
                value="1"
                class="float-left"
                :disabled="form.pessoa_id > 0"
                ><i class="fa fa-2x fa-male"></i> Pessoa Física</b-form-radio
              >
              <b-form-radio
                @input="ajustaMascara()"
                value="2"
                class="float-left"
                :disabled="form.pessoa_id > 0"
                ><i class="fa fa-2x fa-building"></i> Pessoa
                Jurídica</b-form-radio
              >
              <b-form-radio
                @input="ajustaMascara()"
                value="3"
                class="float-left"
                :disabled="form.pessoa_id > 0"
                ><i class="fa fa-2x fa-institution"></i> Pessoa
                Estrangeira</b-form-radio
              >
            </b-form-radio-group>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('tipo_pessoa')"
              v-if="form.errors.has('tipo_pessoa')"
            ></b-form-feedback>
          </div>
          <b-col md="1" sm="1" class="pl-0">
            <label>Vip Nacional</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.vip_nacional"
                :options="this.$parent.optionsLivVipNacional"
                name="vip_nacional"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('vip_nacional')"
              v-if="form.errors.has('vip_nacional')"
            ></b-form-feedback>
          </b-col>
          <b-col md="1" sm="1">
            <label>Vip internacional</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.vip_internacional"
                :options="this.$parent.optionsLivVipInternacional"
                name="vip_internacional"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('vip_internacional')"
              v-if="form.errors.has('vip_internacional')"
            ></b-form-feedback>
          </b-col>
          <b-col md="1" sm="1">
            <label>Fornecedor</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.fornecedor"
                name="fornecedor"
                plain
                stacked
              >
                <b-form-radio
                  v-for="option in fornecedorFieldOptions"
                  :key="'fornecedor-' + option.value"
                  :value="option.value"
                  :disabled="option.disabled"
                  v-b-tooltip.hover="option.shouldShowMigrationTooltip ? fornecedorTooltipMessage : ''"
                >
                  {{ option.text }}
                </b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('fornecedor')"
              v-if="form.errors.has('fornecedor')"
            ></b-form-feedback>
          </b-col>
          <b-col md="1" sm="1">
            <label>Exige averbação?</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.exige_averbacao"
                :options="this.$parent.optionsExigeAverbacao"
                name="exige_averbacao"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('exige_averbacao')"
              v-if="form.errors.has('exige_averbacao')"
            ></b-form-feedback>
          </b-col>
          <b-col md="1" sm="1">
            <label>Valida Opentech?</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.valida_opentech"
                :options="this.$parent.optionsValidaOpentech"
                name="valida_opentech"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('valida_opentech')"
              v-if="form.errors.has('valida_opentech')"
            ></b-form-feedback>
          </b-col>
          <b-col md="1" sm="1">
            <label>Status</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.status"
                :options="this.$parent.optionsLivStatus"
                name="status"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('status')"
              v-if="form.errors.has('status')"
            ></b-form-feedback>
          </b-col>
          <b-col md="1" sm="1">
            <label>Montagem</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.tp_montagem_carga_portal"
                :options="this.$parent.optionsTpMontagemCargaPortal"
                name="tp_montagem_carga_portal"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('tp_montagem_carga_portal')"
              v-if="form.errors.has('tp_montagem_carga_portal')"
            ></b-form-feedback>
          </b-col>
          <b-col md="1" sm="1">
            <label>Envio E-mail parceiro</label>
            <b-form-group>
              <b-form-radio-group
                  v-model="form.envio_email_parceiro"
                  :options="this.$parent.optionsEnvioEmailParceiro"
                  name="envio_email_parceiro"
                  plain
                  stacked
                  value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
                v-text="form.errors.get('envio_email_parceiro')"
                v-if="form.errors.has('envio_email_parceiro')"
            ></b-form-feedback>
          </b-col>
        </b-row>
        <b-row no-gutters>
          <b-col md="1" sm="1">
            <label>Código</label>
            <b-form-input
              type="text"
              placeholder="Código"
              v-model="form.cd"
              name="cd"
              :disabled="modal_acao == 'u'"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('cd')"
              v-if="form.errors.has('cd')"
            ></b-form-feedback>
          </b-col>
          <b-col md="1" sm="1">
            <label>Código ERP</label>
            <b-form-input
              type="text"
              placeholder="Código"
              v-model="form.cd_erp"
              name="cd_erp"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('cd_erp')"
              v-if="form.errors.has('cd_erp')"
            ></b-form-feedback>
          </b-col>
          <b-col md="2" sm="2">
            <label>Número ANTT</label>
            <b-form-input
              type="text"
              placeholder="ANTT"
              v-model="form.antt"
              name="antt"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('antt')"
              v-if="form.errors.has('antt')"
            ></b-form-feedback>
          </b-col>
          <b-col md="2" sm="2">
            <label>Validade ANTT</label>
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Validade ANTT"
              v-model="form.dt_validade_antt"
              class="form-control"
              show-decade-nav
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('dt_validade_antt')"
              v-if="form.errors.has('dt_validade_antt')"
            ></b-form-feedback>
          </b-col>
          <b-col md="3" sm="3">
            <label>Indicador IE</label>
            <multiselect
              v-model="indieSelected"
              :options="this.$parent.optionsLivIndie"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('indie')"
              v-if="form.errors.has('indie')"
            ></b-form-feedback>
          </b-col>
          <b-col md="3" sm="3">
            <label>CNAE</label>
            <multiselect
              v-model="cnaeSelected"
              :options="this.$parent.optionsCnae"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('cnae_id')"
              v-if="form.errors.has('cnae_id')"
            ></b-form-feedback>
          </b-col>
          <b-col md="4" sm="4">
            <label>Tipo de Proprietario</label>
            <multiselect
              v-model="tpProprietarioSelected"
              :options="this.$parent.optionsTpProprietario"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('partipppt_id')"
              v-if="form.errors.has('partipppt_id')"
            ></b-form-feedback>
          </b-col>
          <b-col md="4" sm="4">
            <label>Tipo de Fornecedor</label>
            <multiselect
              v-model="tpFornecedorSelected"
              :options="this.$parent.optionsTpFornecedor"
              :disabled="this.form.fornecedor != 1"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('tp_fornecedor')"
              v-if="form.errors.has('tp_fornecedor')"
            ></b-form-feedback>
          </b-col>
          <b-col md="4" sm="4">
            <label>Categoria CFOP</label>
            <multiselect
              v-model="paramCategoriaCfopSelected"
              :options="this.$parent.optionsParamCategoriaCfop"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('parcatcfo_id')"
              v-if="form.errors.has('parcatcfo_id')"
            ></b-form-feedback>
          </b-col>
        </b-row>
      </b-container>
      <b-container fluid class="p-0">
        <b-row no-gutters>
          <b-tabs style="width: 100%">
            <b-tab v-if="this.form.tipo_pessoa == 2" title="Dados Jurídicos">
              <table class="table">
                <thead>
                  <tr class="bg-blue-grey bg-lighten-5">
                    <th style="width: 36%">CNPJ</th>
                    <th style="width: 32%">Nome Fantasia</th>
                    <th style="width: 32%">Razão Social</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="bg-gray-light" style="display: table-row">
                    <td class="p-0">
                      <b-form-input
                        type="text"
                        placeholder="CNPJ"
                        v-model="pessoa_juridica.cnpj"
                        @input="
                          pessoa_juridica.cnpj = sanitizeCnpjAlfanumerico($event)
                        "
                        v-mask="mascaraCNPJ"
                        name="cnpj"
                        :disabled="modal_acao == 'u'"
                      >
                      </b-form-input>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_juridica.cnpj')"
                        v-if="form.errors.has('pessoa_juridica.cnpj')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <input type="text"
                        placeholder="Nome Fantasia"
                        v-model="pessoa_juridica.nome_fantasia"
                        @input="
                          pessoa_juridica.nome_fantasia = sanitizeTextOnDemand(
                            $event && $event.target ? $event.target.value : ''
                          )
                        "
                        maxlength="60"
                        name="nome_fantasia"
                        style="width: 100%;
                          height: 41px;
                          outline: none;
                          border: 1px solid #CCD6E6;
                          color: #3F587E;">
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_juridica.nome_fantasia')"
                        v-if="form.errors.has('pessoa_juridica.nome_fantasia')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-form-input
                        type="text"
                        placeholder="Razão Social"
                        v-model="pessoa_juridica.razao_social"
                        @input="
                          pessoa_juridica.razao_social = sanitizeTextOnDemand($event)
                        "
                        name="razao_social"
                      >
                      </b-form-input>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_juridica.razao_social')"
                        v-if="form.errors.has('pessoa_juridica.razao_social')"
                      ></b-form-feedback>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="table">
                <thead>
                  <tr class="bg-blue-grey bg-lighten-5">
                    <th style="width: 25%">Inscrição Estadual</th>
                    <th style="width: 25%">Inscrição Municipal</th>
                    <th style="width: 25%">Inscrição Suframa</th>
                    <th style="width: 25%">Código Regime Tributário</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="bg-gray-light" style="display: table-row">
                    <td class="p-0">
                      <b-form-input
                        type="text"
                        placeholder="Inscr. Estadual"
                        v-model="pessoa_juridica.inscricao_estadual"
                        name="inscricao_estadual"
                      >
                      </b-form-input>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_juridica.inscricao_estadual')"
                        v-if="form.errors.has('pessoa_juridica.inscricao_estadual')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-form-input
                        type="text"
                        placeholder="Inscr. Municipal"
                        v-model="pessoa_juridica.inscricao_municipal"
                        name="inscricao_municipal"
                      >
                      </b-form-input>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_juridica.inscricao_municipal')"
                        v-if="form.errors.has('pessoa_juridica.inscricao_municipal')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-form-input
                        type="text"
                        placeholder="Inscr. Suframa"
                        v-model="pessoa_juridica.inscricao_suframa"
                        name="inscricao_suframa"
                      >
                      </b-form-input>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_juridica.inscricao_suframa')"
                        v-if="form.errors.has('pessoa_juridica.inscricao_suframa')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-form-input
                        type="text"
                        placeholder="Cód. Regime Tributário"
                        v-model="pessoa_juridica.cd_regime_tributario"
                        name="cd_regime_tributario"
                      >
                      </b-form-input>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_juridica.cd_regime_tributario')"
                        v-if="form.errors.has('pessoa_juridica.cd_regime_tributario')"
                      ></b-form-feedback>
                    </td>
                  </tr>
                </tbody>
              </table>

              <table class="table">
                <thead>
                  <tr class="bg-blue-grey bg-lighten-5">
                    <th style="width: 25%">Simples Nacional</th>
                    <th style="width: 25%">Alíquota Simples</th>
                    <th style="width: 25%">Crédito Presumido</th>
                    <th style="width: 25%">Pedágio na base de calculo ICMS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="bg-gray-light" style="display: table-row">
                    <td class="p-0">
                      <b-form-group>
                        <b-form-radio-group
                          v-model="pessoa_juridica.simples_nacional"
                          :options="this.$parent.optionsLivSimplesNacional"
                          name="simples_nacional"
                          plain
                          stacked
                          value-field="value"
                        ></b-form-radio-group>
                      </b-form-group>
                      <b-form-feedback
                        v-text="form.errors.get('pessoa_juridica.simples_nacional')"
                        v-if="form.errors.has('pessoa_juridica.simples_nacional')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-form-input
                        type="text"
                        placeholder="Alíquota Simples"
                        v-model="pessoa_juridica.aliquota_simples"
                        name="aliquota_simples"
                      >
                      </b-form-input>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_juridica.aliquota_simples')"
                        v-if="form.errors.has('pessoa_juridica.aliquota_simples')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-form-group>
                        <b-form-radio-group
                          v-model="pessoa_juridica.credito_presumido"
                          :options="this.$parent.optionsLivCreditoPresumido"
                          name="credito_presumido"
                          plain
                          stacked
                          value-field="value"
                        ></b-form-radio-group>
                      </b-form-group>
                      <b-form-feedback
                        v-text="form.errors.get('pessoa_juridica.credito_presumido')"
                        v-if="form.errors.has('pessoa_juridica.credito_presumido')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-form-group>
                        <b-form-radio-group
                          v-model="pessoa_juridica.pedagio_base_calculo_icms"
                          :options="
                            this.$parent.optionsLivPedagioBaseCalculoIcms
                          "
                          name="pedagio_base_calculo_icms"
                          plain
                          stacked
                          value-field="value"
                        ></b-form-radio-group>
                      </b-form-group>
                      <b-form-feedback
                        v-text="form.errors.get('pessoa_juridica.pedagio_base_calculo_icms')"
                        v-if="form.errors.has('pessoa_juridica.pedagio_base_calculo_icms')"
                      ></b-form-feedback>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-tab>
            <b-tab v-if="this.form.tipo_pessoa == 3" title="Pessoa Estrangeira">
              <table class="table">
                <thead>
                  <tr class="bg-blue-grey bg-lighten-5">
                    <th style="width: 36%">Nome</th>
                    <th style="width: 32%">CUIT</th>
                    <th style="width: 32%">Código País</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="bg-gray-light" style="display: table-row">
                    <td class="p-0">
                      <b-form-input
                        type="text"
                        placeholder="Nome"
                        v-model="pessoa_outros.nome"
                        @input="pessoa_outros.nome = sanitizeTextOnDemand($event)"
                        name="nome"
                      >
                      </b-form-input>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_outros.nome')"
                        v-if="form.errors.has('pessoa_outros.nome')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-form-input
                        type="text"
                        placeholder="CUIT"
                        v-model="pessoa_outros.cuit"
                        v-mask="mascaraDoc"
                        name="cuit"
                      >
                      </b-form-input>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_outros.cuit')"
                        v-if="form.errors.has('pessoa_outros.cuit')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-form-input
                        type="text"
                        placeholder="Código País"
                        v-model="pessoa_outros.cd_pais"
                        name="cd_pais"
                      >
                      </b-form-input>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_outros.cd_pais')"
                        v-if="form.errors.has('pessoa_outros.cd_pais')"
                      ></b-form-feedback>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-tab>
            <b-tab v-if="this.form.tipo_pessoa == 1" title="Pessoa Física">
              <table class="table">
                <thead>
                  <tr class="bg-blue-grey bg-lighten-5">
                    <th style="width: 20%">Nome</th>
                    <th style="width: 10%">CPF</th>
                    <th style="width: 10%">Data de nascimento</th>
                    <th style="width: 10%">Data de emissão do CPF</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="bg-gray-light" style="display: table-row">
                    <td class="p-0">
                      <b-form-input
                        type="text"
                        placeholder="Nome"
                        v-model="pessoa_fisica.nome"
                        @input="pessoa_fisica.nome = sanitizeTextOnDemand($event)"
                        name="nome"
                      >
                      </b-form-input>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_fisica.nome')"
                        v-if="form.errors.has('pessoa_fisica.nome')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-form-input
                        type="text"
                        placeholder="CPF"
                        v-model="pessoa_fisica.cpf"
                        v-mask="mascaraDoc"
                        name="CPF"
                        :disabled="modal_acao == 'u'"
                      >
                      </b-form-input>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_fisica.cpf')"
                        v-if="form.errors.has('pessoa_fisica.cpf')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-form-datepicker
                        locale="pt-br"
                        reset-button
                        placeholder="Data de nascto."
                        show-decade-nav
                        v-model="pessoa_fisica.dt_nascto"
                        class="form-control"
                        :date-format-options="{
                          day: 'numeric',
                          month: 'numeric',
                          year: 'numeric',
                        }"
                      >
                      </b-form-datepicker>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_fisica.dt_nascto')"
                        v-if="form.errors.has('pessoa_fisica.dt_nascto')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-form-datepicker
                        locale="pt-br"
                        reset-button
                        placeholder="Emissão CPF"
                        show-decade-nav
                        v-model="pessoa_fisica.dt_emissao_cpf"
                        class="form-control"
                        :date-format-options="{
                          day: 'numeric',
                          month: 'numeric',
                          year: 'numeric',
                        }"
                      >
                      </b-form-datepicker>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_fisica.dt_emissao_cpf')"
                        v-if="form.errors.has('pessoa_fisica.dt_emissao_cpf')"
                      ></b-form-feedback>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="table">
                <thead>
                  <tr class="bg-blue-grey bg-lighten-5">
                    <th style="width: 10%">RG/identidade</th>
                    <th style="width: 5%">Uf de Emissão do RG</th>
                    <th style="width: 15%">Relacionamento</th>
                    <th style="width: 10%">Naturalidade</th>
                    <th style="width: 10%">Nacionalidade</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="bg-gray-light" style="display: table-row">
                    <td class="p-0">
                      <b-form-input
                        type="text"
                        placeholder="RG/Identidade"
                        v-model="pessoa_fisica.identidade"
                        name="RG"
                      >
                      </b-form-input>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_fisica.identidade')"
                        v-if="form.errors.has('pessoa_fisica.identidade')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <multiselect
                        v-model="ufRgSelected"
                        :options="this.$parent.optionsRgUf"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Selecione"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                      ></multiselect>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_fisica.uf_id_identidade')"
                        v-if="form.errors.has('pessoa_fisica.uf_id_identidade')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <multiselect
                        v-model="relacionamentoSelected"
                        :options="this.$parent.optionsParamRelacionamento"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Selecione"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                      ></multiselect>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_fisica.relacionamento')"
                        v-if="form.errors.has('pessoa_fisica.relacionamento')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <multiselect
                        v-model="naturalidadeSelected"
                        :options="this.$parent.optionsMunicipio"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Selecione"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                      ></multiselect>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_fisica.municipio_id')"
                        v-if="form.errors.has('pessoa_fisica.municipio_id')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <multiselect
                        v-model="nacionalidadeSelected"
                        :options="this.$parent.optionsParamNacionalidade"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Selecione"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                      ></multiselect>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_fisica.parnac_id')"
                        v-if="form.errors.has('pessoa_fisica.parnac_id')"
                      ></b-form-feedback>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="table">
                <thead>
                  <tr class="bg-blue-grey bg-lighten-5">
                    <th style="width: 10%">Sexo</th>
                    <th style="width: 20%">Ocupação</th>
                    <th style="width: 10%">Estado civil</th>
                    <th style="width: 10%">Situação da residência</th>
                    <th style="width: 10%">Data início de residência</th>
                    <th v-if="this.paramOcupacaoSelected.label == 'AJUDANTE'" 
                        style="width:10%">Nome do pai</th>
                    <th v-if="this.paramOcupacaoSelected.label != 'AJUDANTE'" 
                        style="width: 20%">Nome do pai</th>
                    <th v-if="this.paramOcupacaoSelected.label == 'AJUDANTE'" 
                        style="width:10%">Nome da mãe</th>
                    <th v-if="this.paramOcupacaoSelected.label != 'AJUDANTE'" 
                        style="width: 20%">Nome da mãe</th>
                    <th v-if="this.paramOcupacaoSelected.label == 'AJUDANTE'" 
                        style="width:5%">Tipo Vínculo</th>
                    <th v-if="this.paramOcupacaoSelected.label != 'AJUDANTE'" 
                        style="width: 10%"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="bg-gray-light" style="display: table-row;">
                    <td class="p-0">
                      <b-form-group>
                        <b-form-radio-group
                          v-model="pessoa_fisica.sexo"
                          :options="this.$parent.optionsSexo"
                          name="sexo"
                          plain
                          stacked
                          value-field="value"
                        ></b-form-radio-group>
                      </b-form-group>
                      <b-form-feedback
                        v-text="form.errors.get('pessoa_fisica.sexo')"
                        v-if="form.errors.has('pessoa_fisica.sexo')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <multiselect
                        v-model="paramOcupacaoSelected"
                        :options="this.$parent.optionsParamOcupacao"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Selecione"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                      ></multiselect>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_fisica.parocupa_id')"
                        v-if="form.errors.has('pessoa_fisica.parocupa_id')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <multiselect
                        v-model="paramEstadoCivilSelected"
                        :options="this.$parent.optionsParamEstadoCivil"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Selecione"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                      ></multiselect>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_fisica.parestciv_id')"
                        v-if="form.errors.has('pessoa_fisica.parestciv_id')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <multiselect
                        v-model="tpSituacaoResidenciaSelected"
                        :options="this.$parent.optionsTpSituacaoResidencia"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Selecione"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                      ></multiselect>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_fisica.tp_situacao_residencia')"
                        v-if="form.errors.has('pessoa_fisica.tp_situacao_residencia')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-form-datepicker
                        locale="pt-br"
                        reset-button
                        placeholder="Início de residência"
                        show-decade-nav
                        v-model="pessoa_fisica.dt_inicio_residencia"
                        class="form-control"
                        :date-format-options="{
                          day: 'numeric',
                          month: 'numeric',
                          year: 'numeric',
                        }"
                      >
                      </b-form-datepicker>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_fisica.dt_inicio_residencia')"
                        v-if="form.errors.has('pessoa_fisica.dt_inicio_residencia')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-form-input
                        type="text"
                        placeholder="Nome do pai"
                        v-model="pessoa_fisica.nome_pai"
                        @input="
                          pessoa_fisica.nome_pai = sanitizeTextOnDemand($event)
                        "
                        name="nome_pai"
                      >
                      </b-form-input>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_fisica.nome_pai')"
                        v-if="form.errors.has('pessoa_fisica.nome_pai')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-form-input
                        type="text"
                        placeholder="Nome da mãe"
                        v-model="pessoa_fisica.nome_mae"
                        @input="
                          pessoa_fisica.nome_mae = sanitizeTextOnDemand($event)
                        "
                        name="nome_mae"
                      >
                      </b-form-input>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_fisica.nome_mae')"
                        v-if="form.errors.has('pessoa_fisica.nome_mae')"
                      ></b-form-feedback>
                    </td>
                    <td class="pl-1">
                      <b-form-group>
                        <b-form-radio-group
                          v-model="form.tp_vinculo_ajudante"
                          v-if="this.paramOcupacaoSelected.label == 'AJUDANTE'"
                          :options="this.$parent.optionsTpVinculoAjudante"
                          name="tp_vinculo_ajudante"
                          plain
                          stacked
                          value-field="value"
                        ></b-form-radio-group>
                      </b-form-group>
                      <b-form-feedback
                        v-text="form.errors.get('tp_vinculo_ajudante')"
                        v-if="form.errors.has('tp_vinculo_ajudante')"
                      ></b-form-feedback>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-tab>
            <b-tab v-if="this.form.tipo_pessoa == 1" title="Motorista">
              <table class="table">
                <thead>
                  <tr class="bg-blue-grey bg-lighten-5">
                    <th style="width: 20%">CNH</th>
                    <th style="width: 20%">Número registro CNH</th>
                    <th style="width: 15%">Data Emissão CNH</th>
                    <th style="width: 15%">Data vencimento CNH</th>
                    <th style="width: 15%">UF de emissão</th>
                    <th style="width: 15%">Categoria</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="bg-gray-light" style="display: table-row">
                    <td class="p-0">
                      <b-form-input
                        type="text"
                        placeholder="CNH"
                        v-model="pessoa_motorista.cnh"
                        name="cnh"
                      >
                      </b-form-input>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_motorista.cnh')"
                        v-if="form.errors.has('pessoa_motorista.cnh')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-form-input
                        type="text"
                        placeholder="Registro CNH"
                        v-model="pessoa_motorista.num_registro_cnh"
                        name="num_registro_cnh"
                        v-mask="'###########'"
                      >
                      </b-form-input>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_motorista.num_registro_cnh')"
                        v-if="form.errors.has('pessoa_motorista.num_registro_cnh')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-form-datepicker
                        locale="pt-br"
                        reset-button
                        placeholder="Emissão CNH"
                        show-decade-nav
                        v-model="pessoa_motorista.dt_emissao_cnh"
                        class="form-control"
                        :date-format-options="{
                          day: 'numeric',
                          month: 'numeric',
                          year: 'numeric',
                        }"
                      >
                      </b-form-datepicker>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_motorista.dt_emissao_cnh')"
                        v-if="form.errors.has('pessoa_motorista.dt_emissao_cnh')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-form-datepicker
                        locale="pt-br"
                        reset-button
                        placeholder="Vencimento CNH"
                        show-decade-nav
                        v-model="pessoa_motorista.dt_vencimento_cnh"
                        class="form-control"
                        :date-format-options="{
                          day: 'numeric',
                          month: 'numeric',
                          year: 'numeric',
                        }"
                      >
                      </b-form-datepicker>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_motorista.dt_vencimento_cnh')"
                        v-if="form.errors.has('pessoa_motorista.dt_vencimento_cnh')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <multiselect
                        v-model="ufEmissaoSelected"
                        :options="this.$parent.optionsUf"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Selecione"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                      ></multiselect>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_motorista.uf_id_emissao')"
                        v-if="form.errors.has('pessoa_motorista.uf_id_emissao')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <multiselect
                        v-model="categoriaSelected"
                        :options="this.$parent.optionsCategoriaCnh"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Selecione"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                      ></multiselect>
                      <b-form-feedback
                        class="text-danger"
                        v-text="form.errors.get('pessoa_motorista.categoria')"
                        v-if="form.errors.has('pessoa_motorista.categoria')"
                      ></b-form-feedback>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="table">
                <thead>
                  <tr class="bg-blue-grey bg-lighten-5">
                    <th style="width: 10%">Tipo Vínculo</th>
                    <th style="width: 40%">Obs.</th>
                    <th style="width: 50%">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="bg-gray-light" style="display: table-row">
                    <td class="p-0">
                      <b-form-group>
                        <b-form-radio-group
                          v-model="pessoa_motorista.tp_vinculo"
                          :options="this.$parent.optionsTpVinculoMotorista"
                          name="tp_vinculo"
                          plain
                          stacked
                          value-field="value"
                        ></b-form-radio-group>
                      </b-form-group>
                      <b-form-feedback
                        v-text="form.errors.get('pessoa_motorista.tp_vinculo')"
                        v-if="form.errors.has('pessoa_motorista.tp_vinculo')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-form-textarea
                        v-model="pessoa_motorista.obs"
                        name="obs"
                        placeholder="Observação"
                        :rows="3"
                        :max-rows="6"
                      >
                      </b-form-textarea>
                      <b-form-feedback
                        v-text="form.errors.get('pessoa_motorista.obs')"
                        v-if="form.errors.has('pessoa_motorista.obs')"
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-form-group>
                        <b-form-radio-group
                          v-model="pessoa_motorista.status"
                          :options="this.$parent.optionsLivStatusMotorista"
                          name="pessoa_motorista.status"
                          plain
                          stacked
                          value-field="value"
                        ></b-form-radio-group>
                      </b-form-group>
                      <b-form-feedback
                        v-text="form.errors.get('pessoa_motorista.status')"
                        v-if="form.errors.has('pessoa_motorista.status')"
                      ></b-form-feedback>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-tab>
            <b-tab title="Referências"
              v-if="this.form.tipo_pessoa == 1 || this.form.tipo_pessoa == 2"
            >
              <template v-for="(row, index) in pessoa_referencia">
                <table class="table">
                  <thead>
                    <tr class="bg-blue-grey bg-lighten-5">
                      <th style="width: 25%">Nome</th>
                      <th style="width: 5%">DDD</th>
                      <th style="width: 10%">Número tel.</th>
                      <th style="width: 15%">E-mail</th>
                      <th style="width: 20%">Relacionamento</th>
                      <th style="width: 25%">Município</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="bg-gray-light" style="display: table-row">
                      <td class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="Nome"
                          v-model="row.nome"
                          @input="row.nome = sanitizeTextOnDemand($event)"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_referencia.' + index + '.nome'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_referencia.' + index + '.nome'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="DDD"
                          v-model="row.ddd"
                          v-mask="'##'"
                          @input="row.ddd = sanitizeOnlyDigits($event, 2)"
                          maxlength="2"
                          inputmode="numeric"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_referencia.' + index + '.ddd'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_referencia.' + index + '.ddd'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="Número Tel."
                          v-model="row.numero_tel"
                          v-mask="'#########'"
                          @input="row.numero_tel = sanitizeOnlyDigits($event, 9)"
                          maxlength="9"
                          inputmode="numeric"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_referencia.' + index + '.numero_tel'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_referencia.' + index + '.numero_tel'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="E-mail"
                          v-model="row.email"
                          @input="row.email = sanitizeEmail($event)"
                          :state="getEmailFieldState(row.email)"
                        >
                        </b-form-input>
                        <b-form-invalid-feedback
                          v-if="getEmailFieldState(row.email) === false"
                        >
                          E-mail inválido. Exemplo: usuario@dominio.com ou usuario@dominio.com.br
                        </b-form-invalid-feedback>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_referencia.' + index + '.email'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_referencia.' + index + '.email'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <multiselect
                          v-model="row.parrel"
                          :options="optionsParamRelacionamento"
                          track-by="value"
                          label="label"
                          :hide-selected="true"
                          placeholder="Selecione"
                          tag-placeholder="Selecionar"
                          select-label="Selecionar"
                          selected-label="Selecionado"
                          deselect-label="Remover"
                        ></multiselect>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_referencia.' + index + '.parrel_id'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_referencia.' + index + '.parrel_id'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <multiselect
                          v-model="row.municipio"
                          :options="optionsMunicipio"
                          track-by="value"
                          label="label"
                          :hide-selected="true"
                          placeholder="Selecione"
                          tag-placeholder="Selecionar"
                          select-label="Selecionar"
                          selected-label="Selecionado"
                          deselect-label="Remover"
                        ></multiselect>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_referencia.' + index + '.municipio_id'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_referencia.' + index + '.municipio_id'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table class="table">
                  <thead>
                    <tr class="bg-blue-grey bg-lighten-5">
                      <th style="width: 15%">CPF</th>
                      <th style="width: 15%">Cargo</th>
                      <th style="width: 15%">RG/Identidade</th>
                      <th style="width: 5%">Orgão de expedição</th>
                      <th style="width: 20%">Data de Nascimento</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="bg-gray-light" style="display: table-row">
                      <td class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="CPF"
                          v-model="row.cpf"
                          v-mask="mascaraCPF"
                          name="CPF"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_referencia.' + index + '.cpf'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_referencia.' + index + '.cpf'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="Cargo"
                          v-model="row.cargo"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_referencia.' + index + '.cargo'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_referencia.' + index + '.cargo'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="RG/Identidade"
                          v-model="row.identidade"
                          name="RG"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_referencia.' + index + '.identidade'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_referencia.' + index + '.identidade'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="Expedição"
                          v-model="row.orgao_identidade"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_referencia.' + index + '.orgao_identidade'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_referencia.' + index + '.orgao_identidade'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <b-form-datepicker
                          locale="pt-br"
                          reset-button
                          show-decade-nav
                          placeholder="Data de Nascimento"
                          v-model="row.dt_nascto"
                          class="form-control"
                          :date-format-options="{
                            day: 'numeric',
                            month: 'numeric',
                            year: 'numeric',
                          }"
                        >
                        </b-form-datepicker>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_referencia.' + index + '.dt_nascto'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_referencia.' + index + '.dt_nascto'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table class="table">
                  <thead>
                    <tr class="bg-blue-grey bg-lighten-5">
                      <th style="width: 20%">Endereço</th>
                      <th style="width: 10%">Número</th>
                      <th style="width: 20%">Bairro</th>
                      <th style="width: 15%">Complemento</th>
                      <th style="width: 10%">CEP</th>
                      <th style="width: 5%">DDD 2</th>
                      <th style="width: 10%">Número tel. 2</th>
                      <th style="width: 5%">Status</th>
                      <th style="width: 5%">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="bg-gray-light" style="display: table-row">
                      <td class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="Endereço"
                          v-model="row.endereco"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_referencia.' + index + '.endereco'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_referencia.' + index + '.endereco'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="Número"
                          v-model="row.numero"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_referencia.' + index + '.numero'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_referencia.' + index + '.numero'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="Bairro"
                          v-model="row.bairro"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_referencia.' + index + '.bairro'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_referencia.' + index + '.bairro'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="Complemento"
                          v-model="row.complemento"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_referencia.' + index + '.complemento'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_referencia.' + index + '.complemento'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="CEP"
                          v-model="row.cep"
                          v-mask="'#####-###'"
                          name="cep"
                          @change="getCep(index, 2)"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_referencia.' + index + '.cep'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_referencia.' + index + '.cep'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="DDD 2"
                          v-model="row.ddd_2"
                          v-mask="'##'"
                          @input="row.ddd_2 = sanitizeOnlyDigits($event, 2)"
                          maxlength="2"
                          inputmode="numeric"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_referencia.' + index + '.ddd_2'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_referencia.' + index + '.ddd_2'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="Número Tel."
                          v-model="row.numero_2"
                          v-mask="'#########'"
                          @input="row.numero_2 = sanitizeOnlyDigits($event, 9)"
                          maxlength="9"
                          inputmode="numeric"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_referencia.' + index + '.numero_2'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_referencia.' + index + '.numero_2'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <b-form-group>
                          <b-form-radio-group
                            v-model="row.status"
                            :options="optionsLivStatusReferencia"
                            :name="'pessoa_referencia.status' + index"
                            plain
                            stacked
                            value-field="value"
                          ></b-form-radio-group>
                        </b-form-group>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_referencia.' + index + '.status'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_referencia.' + index + '.status'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td align="text-right">
                        <i
                          class="fa fa-times"
                          style="cursor: pointer"
                          v-b-tooltip.hover.right="'Remover Linha'"
                          v-on:click="removeRowReferencia(index)"
                        ></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </template>
              <table class="table">
                <tbody>
                  <tr class="table-info" style="display: table-row">
                    <td colspan="8" style="width: 90%"></td>
                    <td class="text-right" style="width: 90%">
                      <i
                        class="fa fa-plus-square"
                        v-on:click="addRowReferencia($event)"
                        v-b-tooltip.hover.right="'Adicionar referência'"
                        style="cursor: pointer"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-tab>
            <b-tab title="Endereço">
              <table class="table">
                <tr class="bg-blue-grey bg-lighten-5">
                  <th style="width: 6%">CEP</th>
                  <th style="width: 15%">Endereço</th>
                  <th style="width: 4%">Número</th>
                  <th style="width: 10%">Complemento</th>
                  <th style="width: 10%">Bairro</th>
                  <th style="width: 15%">Município</th>
                  <th style="width: 10%">Tipo</th>
                  <th style="width: 5%">Padrão ?</th>
                  <th style="width: 5%">Ações</th>
                </tr>
                <tbody v-for="(row, index) in pessoa_endereco">
                  <tr style="display: table-row">
                    <td class="p-0">
                      <b-form-input
                        type="text"
                        placeholder="CEP"
                        v-model="row.cep"
                        v-mask="'#####-###'"
                        name="cep"
                        @change="getCep(index, 1)"
                      >
                      </b-form-input>
                      <b-form-feedback
                        class="text-danger"
                        v-text="
                          form.errors.get('pessoa_endereco.' + index + '.cep')
                        "
                        v-if="
                          form.errors.has('pessoa_endereco.' + index + '.cep')
                        "
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-form-input
                        type="text"
                        placeholder="Endereço"
                        v-model="row.endereco"
                        name="endereco"
                      >
                      </b-form-input>
                      <b-form-feedback
                        class="text-danger"
                        v-text="
                          form.errors.get(
                            'pessoa_endereco.' + index + '.endereco'
                          )
                        "
                        v-if="
                          form.errors.has(
                            'pessoa_endereco.' + index + '.endereco'
                          )
                        "
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-form-input
                        type="text"
                        placeholder="Número"
                        v-model="row.numero"
                        name="numero"
                      >
                      </b-form-input>
                      <b-form-feedback
                        class="text-danger"
                        v-text="
                          form.errors.get(
                            'pessoa_endereco.' + index + '.numero'
                          )
                        "
                        v-if="
                          form.errors.has(
                            'pessoa_endereco.' + index + '.numero'
                          )
                        "
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-form-input
                        type="text"
                        placeholder="Complemento"
                        v-model="row.complemento"
                        name="complemento"
                      >
                      </b-form-input>
                      <b-form-feedback
                        class="text-danger"
                        v-text="
                          form.errors.get(
                            'pessoa_endereco.' + index + '.complemento'
                          )
                        "
                        v-if="
                          form.errors.has(
                            'pessoa_endereco.' + index + '.complemento'
                          )
                        "
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-form-input
                        type="text"
                        placeholder="Bairro"
                        v-model="row.bairro"
                        name="bairro"
                      >
                      </b-form-input>
                      <b-form-feedback
                        class="text-danger"
                        v-text="
                          form.errors.get(
                            'pessoa_endereco.' + index + '.bairro'
                          )
                        "
                        v-if="
                          form.errors.has(
                            'pessoa_endereco.' + index + '.bairro'
                          )
                        "
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <multiselect
                        v-model="row.municipio"
                        :options="optionsMunicipio"
                        track-by="value"
                        label="label"
                        :name="'pessoa_endereco.municipio_id' + index"
                        :hide-selected="true"
                        placeholder="Selecione"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                      ></multiselect>
                      <b-form-feedback
                        class="text-danger"
                        v-text="
                          form.errors.get(
                            'pessoa_endereco.' + index + '.municipio_id'
                          )
                        "
                        v-if="
                          form.errors.has(
                            'pessoa_endereco.' + index + '.municipio_id'
                          )
                        "
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <multiselect
                        v-model="row.parend"
                        :options="optionsParEnd"
                        track-by="value"
                        label="label"
                        :name="'pessoa_endereco.parend_id' + index"
                        :hide-selected="true"
                        placeholder="Selecione"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                      ></multiselect>
                      <b-form-feedback
                        class="text-danger"
                        v-text="
                          form.errors.get(
                            'pessoa_endereco.' + index + '.parend_id'
                          )
                        "
                        v-if="
                          form.errors.has(
                            'pessoa_endereco.' + index + '.parend_id'
                          )
                        "
                      ></b-form-feedback>
                    </td>
                    <td>
                      <b-form-checkbox
                        v-model="row.is_padrao"
                        :name="'pessoa_endereco.is_padrao' + index"
                        value="1"
                        unchecked-value="2"
                      >
                      </b-form-checkbox>
                      <b-form-feedback
                        class="text-danger"
                        v-text="
                          form.errors.get(
                            'pessoa_endereco.' + index + '.is_padrao'
                          )
                        "
                        v-if="
                          form.errors.has(
                            'pessoa_endereco.' + index + '.is_padrao'
                          )
                        "
                      ></b-form-feedback>
                    </td>
                    <td align="text-right">
                      <i
                        class="fa fa-times"
                        style="cursor: pointer"
                        v-b-tooltip.hover.right="'Remover Endereço'"
                        v-on:click="removeRowEndereco(index)"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="table">
                <tbody>
                  <tr class="table-info" style="display: table-row">
                    <td colspan="11" style="width: 90%"></td>
                    <td class="text-right" style="width: 90%">
                      <i
                        class="fa fa-plus-square"
                        v-on:click="addRowEndereco($event)"
                        v-b-tooltip.hover.right="'Adicionar Endereço'"
                        style="cursor: pointer"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-tab>
            <b-tab title="Financeiro">
              <template v-for="(row, index) in pessoa_financeiro">
                <table class="table table-striped">
                  <thead>
                    <tr class="bg-blue-grey bg-lighten-5">
                      <th style="width: 10%">Agência</th>
                      <th style="width: 10%">Dígito</th>
                      <th style="width: 20%">Agência Nome</th>
                      <th style="width: 10%">Banco</th>
                      <th style="width: 10%">Tipo da Conta</th>
                      <th style="width: 15%">Conta Corrente</th>
                      <th style="width: 10%">Cc Dígito</th>
                      <th style="width: 15%">Número conta</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="bg-gray-light" style="display: table-row">
                      <td class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="Agência"
                          v-model="row.agencia"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_financeiro.' + index + '.agencia'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_financeiro.' + index + '.agencia'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="Dígito"
                          v-model="row.agencia_digito"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_financeiro.' + index + '.agencia_digito'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_financeiro.' + index + '.agencia_digito'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="Agência Nome"
                          v-model="row.agencia_nome"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_financeiro.' + index + '.agencia_nome'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_financeiro.' + index + '.agencia_nome'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <multiselect
                          v-model="row.parban"
                          :options="optionsParamBanco"
                          track-by="value"
                          label="label"
                          :hide-selected="true"
                          placeholder="Selecione"
                          tag-placeholder="Selecionar"
                          select-label="Selecionar"
                          selected-label="Selecionado"
                          deselect-label="Remover"
                        ></multiselect>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_financeiro.' + index + '.parban_id'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_financeiro.' + index + '.parban_id'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      
                      <td class="p-0">
                        <multiselect
                          v-model="row.tp_conta"
                          :options="optionsTpConta"
                          track-by="value"
                          label="label"
                          :hide-selected="true"
                          placeholder="Selecione"
                          tag-placeholder="Selecionar"
                          select-label="Selecionar"
                          selected-label="Selecionado"
                          deselect-label="Remover"
                        ></multiselect>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_financeiro.' + index + '.tp_conta'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_financeiro.' + index + '.tp_conta'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="Conta Corrente"
                          v-model="row.conta_corrente"
                          maxlength="10"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_financeiro.' + index + '.conta_corrente'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_financeiro.' + index + '.conta_corrente'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="Conta Corrente Dígito"
                          v-model="row.conta_corrente_digito"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_financeiro.' +
                                index +
                                '.conta_corrente_digito'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_financeiro.' +
                                index +
                                '.conta_corrente_digito'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="Número Conta"
                          v-model="row.numero_acc"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_financeiro.' + index + '.numero_acc'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_financeiro.' + index + '.numero_acc'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table class="table table-striped">
                  <thead>
                    <tr class="bg-blue-grey bg-lighten-5">
                      <th style="width: 10%">Prazo Pag.</th>
                      <th style="width: 15%">Forma Pag.</th>
                      <th style="width: 15%">Obs.</th>
                      <th style="width: 5%">Padrão ?</th>
                      <th style="width: 5%">Status</th>
                      <th style="width: 5%">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="bg-gray-light" style="display: table-row">
                      <td class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="Prazo"
                          v-model="row.prazo_pagamento"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_financeiro.' + index + '.prazo_pagamento'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_financeiro.' + index + '.prazo_pagamento'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <multiselect
                          v-model="row.parforpag"
                          :options="optionsFormaPag"
                          track-by="value"
                          label="label"
                          :hide-selected="true"
                          placeholder="Selecione"
                          tag-placeholder="Selecionar"
                          select-label=""
                          selected-label="Selecionado"
                          deselect-label="Remover"
                        ></multiselect>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_financeiro.' + index + '.parforpag_id'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_financeiro.' + index + '.parforpag_id'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <b-form-textarea
                          v-model="row.obs"
                          name="obs"
                          placeholder="Observação"
                          :rows="3"
                          :max-rows="6"
                        >
                        </b-form-textarea>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_financeiro.' + index + '.obs'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_financeiro.' + index + '.obs'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td>
                        <b-form-checkbox
                          v-model="row.is_padrao"
                          :name="'pessoa_financeiro.is_padrao' + index"
                          value="1"
                          unchecked-value="2"
                        >
                        </b-form-checkbox>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_financeiro.' + index + '.is_padrao'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_financeiro.' + index + '.is_padrao'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td class="p-0">
                        <b-form-group>
                          <b-form-radio-group
                            v-model="row.status"
                            :options="optionsLivStatusFinanceiro"
                            :name="'pessoa_financeiro.status' + index"
                            plain
                            stacked
                            value-field="value"
                          ></b-form-radio-group>
                        </b-form-group>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_financeiro.' + index + '.status'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_financeiro.' + index + '.status'
                            )
                          "
                        ></b-form-feedback>
                      </td>
                      <td align="text-right">
                        <i
                          class="fa fa-times"
                          style="cursor: pointer"
                          v-b-tooltip.hover.right="'Remover Linha'"
                          v-on:click="removeRowFinanceiro(index)"
                        ></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </template>
              <table class="table">
                <tbody>
                  <tr class="table-info" style="display: table-row">
                    <td colspan="11" style="width: 90%"></td>
                    <td class="text-right" style="width: 90%">
                      <i
                        class="fa fa-plus-square"
                        v-on:click="addRowFinanceiro($event)"
                        v-b-tooltip.hover.right="'Adicionar Linha'"
                        style="cursor: pointer"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-tab>
            <b-tab title="Email">
              <table class="table">
                <thead>
                  <tr class="bg-blue-grey bg-lighten-5">
                    <th style="width: 15%">Padrão</th>
                    <th style="width: 30%">Email</th>
                    <th style="width: 30%">Tipo Email</th>
                    <th style="width: 15%">Status</th>
                    <th style="width: 10%">Ações</th>
                  </tr>
                </thead>
                <tbody v-for="(row, index) in pessoa_contato_email">
                  <tr style="display: table-row">
                    <td>
                      <b-form-checkbox
                        v-model="row.email_default"
                        :name="'pessoa_contato_email.email_default' + index"
                        value="1"
                        unchecked-value="2"
                      >
                      </b-form-checkbox>
                      <b-form-feedback
                        class="text-danger"
                        v-text="
                          form.errors.get(
                            'pessoa_contato_email.' + index + '.email_default'
                          )
                        "
                        v-if="
                          form.errors.has(
                            'pessoa_contato_email.' + index + '.email_default'
                          )
                        "
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-col class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="Email"
                          v-model="row.email"
                          @input="row.email = sanitizeEmail($event)"
                          :state="getEmailFieldState(row.email)"
                        >
                        </b-form-input>
                        <b-form-invalid-feedback
                          v-if="getEmailFieldState(row.email) === false"
                        >
                          E-mail inválido. Exemplo: usuario@dominio.com ou usuario@dominio.com.br
                        </b-form-invalid-feedback>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_contato_email.' + index + '.email'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_contato_email.' + index + '.email'
                            )
                          "
                        ></b-form-feedback>
                      </b-col>
                    </td>
                    <td class="p-0">
                      <b-col class="p-0">
                        <multiselect
                          v-model="row.partpema"
                          :options="optionsParTpEma"
                          track-by="value"
                          label="label"
                          :hide-selected="true"
                          placeholder="Selecione"
                          tag-placeholder=""
                          select-label=""
                          selected-label="Selecionado"
                          deselect-label="Remover"
                        ></multiselect>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_contato_email.' + index + '.partpema_id'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_contato_email.' + index + '.partpema_id'
                            )
                          "
                        ></b-form-feedback>
                      </b-col>
                    </td>
                    <td class="p-0 pl-1">
                      <b-form-group>
                        <b-form-radio-group
                        v-model="row.status"
                        :options="optionsLivContatoEmailStatus"
                        :name="'pessoa_contato_email.status' + index"
                          plain
                          stacked
                          value-field="value"
                        ></b-form-radio-group>
                      </b-form-group>
                      <b-form-feedback
                        class="text-danger"
                        v-text="
                          form.errors.get(
                            'pessoa_contato_email.' + index + '.status'
                          )
                        "
                        v-if="
                          form.errors.has(
                            'pessoa_contato_email.' + index + '.status'
                          )
                        "
                      ></b-form-feedback>
                    </td>
                    <td align="text-right">
                      <i
                        class="fa fa-times"
                        style="cursor: pointer"
                        v-b-tooltip.hover.right="'Remover Email'"
                        v-on:click="removeRowEmail(index)"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="table">
                <tbody>
                  <tr class="table-info" style="display: table-row">
                    <td colspan="11" style="width: 90%"></td>
                    <td class="text-right" style="width: 90%">
                      <i
                        class="fa fa-plus-square"
                        v-on:click="addRowEmail($event)"
                        v-b-tooltip.hover.right="'Adicionar Email'"
                        style="cursor: pointer"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-tab>
            <b-tab title="Telefone">
              <table class="table table-striped">
                <thead>
                  <tr class="bg-blue-grey bg-lighten-5">
                    <th style="width: 10%">Padrão</th>
                    <th style="width: 5%">DDD</th>
                    <th style="width: 15%">Número</th>
                    <th style="width: 15%">Tipo Telefone</th>
                    <th style="width: 15%">Operadora</th>
                    <th style="width: 10%">Status</th>
                    <th style="width: 5%">Ações</th>
                  </tr>
                </thead>
                <tbody v-for="(row, index) in pessoa_contato_tel">
                  <tr style="display: table-row">
                    <td>
                      <b-form-checkbox
                        v-model="row.is_padrao"
                        :name="'pessoa_contato_tel.is_padrao' + index"
                        value="1"
                        unchecked-value="2"
                      >
                      </b-form-checkbox>
                      <b-form-feedback
                        class="text-danger"
                        v-text="
                          form.errors.get(
                            'pessoa_contato_tel.' + index + '.is_padrao'
                          )
                        "
                        v-if="
                          form.errors.has(
                            'pessoa_contato_tel.' + index + '.is_padrao'
                          )
                        "
                      ></b-form-feedback>
                    </td>
                    <td class="p-0">
                      <b-col class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="DDD"
                          v-model="row.ddd"
                          v-mask="'##'"
                          @input="row.ddd = sanitizeOnlyDigits($event, 2)"
                          maxlength="2"
                          inputmode="numeric"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_contato_tel.' + index + '.ddd'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_contato_tel.' + index + '.ddd'
                            )
                          "
                        ></b-form-feedback>
                      </b-col>
                    </td>
                    <td class="p-0">
                      <b-col class="p-0">
                        <b-form-input
                          type="text"
                          placeholder="Número"
                          v-model="row.telefone"
                          v-mask="'#########'"
                          @input="row.telefone = sanitizeOnlyDigits($event, 9)"
                          maxlength="9"
                          inputmode="numeric"
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_contato_tel.' + index + '.telefone'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_contato_tel.' + index + '.telefone'
                            )
                          "
                        ></b-form-feedback>
                      </b-col>
                    </td>
                    <td class="p-0">
                      <b-col class="p-0">
                        <multiselect
                          v-model="row.tipo_tel_det"
                          :options="optionsLivTipoTel"
                          track-by="value"
                          label="label"
                          :hide-selected="true"
                          placeholder="Selecione"
                          tag-placeholder=""
                          select-label=""
                          selected-label="Selecionado"
                          deselect-label="Remover"
                        ></multiselect>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_contato_tel.' + index + '.tipo_tel'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_contato_tel.' + index + '.tipo_tel'
                            )
                          "
                        ></b-form-feedback>
                      </b-col>
                    </td>
                    <td class="p-0">
                      <b-col class="p-0">
                        <multiselect
                          v-model="row.partelope"
                          :options="optionsOperadora"
                          track-by="value"
                          label="label"
                          :hide-selected="true"
                          placeholder="Selecione"
                          tag-placeholder=""
                          select-label=""
                          selected-label="Selecionado"
                          deselect-label="Remover"
                        ></multiselect>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form.errors.get(
                              'pessoa_contato_tel.' + index + '.partelope_id'
                            )
                          "
                          v-if="
                            form.errors.has(
                              'pessoa_contato_tel.' + index + '.partelope_id'
                            )
                          "
                        ></b-form-feedback>
                      </b-col>
                    </td>
                    <td class="p-0 pl-1">
                      <b-form-group>
                        <b-form-radio-group
                          v-model="row.status"
                          :options="optionsLivStatusTel"
                          :name="'pessoa_contato_tel.status' + index"
                          plain
                          stacked
                          value-field="value"
                        ></b-form-radio-group>
                      </b-form-group>
                      <b-form-feedback
                        class="text-danger"
                        v-text="
                          form.errors.get(
                            'pessoa_contato_tel.' + index + '.status'
                          )
                        "
                        v-if="
                          form.errors.has(
                            'pessoa_contato_tel.' + index + '.status'
                          )
                        "
                      ></b-form-feedback>
                    </td>
                    <td align="text-right">
                      <i
                        class="fa fa-times"
                        style="cursor: pointer"
                        v-b-tooltip.hover.right="'Remover Telefone'"
                        v-on:click="removeRowTel(index)"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="table">
                <tbody>
                  <tr class="table-info" style="display: table-row">
                    <td colspan="11" style="width: 90%"></td>
                    <td class="text-right" style="width: 90%">
                      <i
                        class="fa fa-plus-square"
                        v-on:click="addRowTel($event)"
                        v-b-tooltip.hover.right="'Adicionar Telelefone'"
                        style="cursor: pointer"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-tab>
            <b-tab title="Observação">
              <b-col>
                <label>Observação</label>
                <b-form-textarea
                  v-model="form.obs"
                  name="obs"
                  placeholder="Observação"
                  :rows="3"
                  :max-rows="6"
                >
                </b-form-textarea>
                <b-form-feedback
                  class="text-danger"
                  v-text="form.errors.get('obs')"
                  v-if="form.errors.has('obs')"
                ></b-form-feedback>
              </b-col>
            </b-tab>
            <b-tab title="Configurações">
              <table class="table table-striped table-responsive">
                <thead>
                  <tr class="bg-blue-grey bg-lighten-5">
                    <th v-if="this.form.tipo_pessoa == 2" style="width: 5%">Retira</th>
                    <th style="width: 15%">Venda de serviço</th>
                    <th style="width: 10%">Gera Pré Fatura</th>
                    <th style="width: 10%">Permite adiantamento</th>
                    <th style="width: 5%">Controla Data de entrega</th>
                    <th style="width: 5%">Layout de Etiqueta</th>
                    <th style="width: 5%">Indicador Edoccob</th>
                    <th style="width: 15%">Grupo Econômico Edoccob</th>
                    <th style="width: 5%">Prazo Edoccob</th>
                    <th style="width: 15%">Quantidade de reentregas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style="display: table-row">
                    <td v-if="this.form.tipo_pessoa == 2" class="p-0">
                      <b-col class="p-0">
                        <b-form-group>
                          <b-form-radio-group
                              v-model="form.retira"
                              :options="this.$parent.optionsRetira"
                              name="retira"
                              plain
                              stacked
                              value-field="value"
                          ></b-form-radio-group>
                        </b-form-group>
                        <b-form-feedback
                            class="text-danger"
                            v-text="form.errors.get('retira')"
                            v-if="form.errors.has('retira')"
                        ></b-form-feedback>
                      </b-col>
                    </td>
                    <td class="p-0">
                      <b-col class="p-0">
                        <b-form-group>
                          <b-form-radio-group
                              v-model="form.status_venda_servico"
                              :options="this.$parent.optionsStatusVendaServico"
                              name="status_venda_servico"
                              plain
                              stacked
                              value-field="value"
                          ></b-form-radio-group>
                        </b-form-group>
                        <b-form-feedback
                            class="text-danger"
                            v-text="form.errors.get('status_venda_servico')"
                            v-if="form.errors.has('status_venda_servico')"
                        ></b-form-feedback>
                      </b-col>
                    </td>
                    <td class="p-0">
                      <b-col class="p-0">
                        <b-form-group>
                          <b-form-radio-group
                            v-model="form.gerar_pre_fatura"
                            :options="this.$parent.optionsGerarPreFatura"
                            name="gerar_pre_fatura"
                            plain
                            stacked
                            value-field="value"
                          ></b-form-radio-group>
                        </b-form-group>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('gerar_pre_fatura')"
                          v-if="form.errors.has('gerar_pre_fatura')"
                        ></b-form-feedback>
                      </b-col>
                    </td>
                    <td class="p-0">
                      <b-col class="p-0">
                        <b-form-group>
                          <b-form-radio-group
                            v-model="form.permitir_adiantamento"
                            :options="this.$parent.optionsPermitirAdiantamento"
                            name="permitir_adiantamento"
                            plain
                            stacked
                            value-field="value"
                          ></b-form-radio-group>
                        </b-form-group>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('permitir_adiantamento')"
                          v-if="form.errors.has('permitir_adiantamento')"
                        ></b-form-feedback>
                      </b-col>
                    </td>
                    <td class="p-0">
                      <b-col class="p-0">
                        <b-form-group>
                          <b-form-radio-group
                            v-model="form.controla_dt_entrega"
                            :options="this.$parent.optionsControlaDtEntrega"
                            name="controla_dt_entrega"
                            plain
                            stacked
                            value-field="value"
                          ></b-form-radio-group>
                        </b-form-group>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('controla_dt_entrega')"
                          v-if="form.errors.has('controla_dt_entrega')"
                        ></b-form-feedback>
                      </b-col>
                    </td>
                    <td class="p-0">
                      <b-col class="p-0">
                        <b-form-group>
                          <b-form-radio-group
                            v-model="form.betilay_id"
                            :options="this.$parent.optionsBEtiquetaLayout"
                            name="betilay_id"
                            plain
                            stacked
                            value-field="value"
                          ></b-form-radio-group>
                        </b-form-group>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('betilay_id')"
                          v-if="form.errors.has('betilay_id')"
                        ></b-form-feedback>
                      </b-col>
                    </td>
                    <td class="p-0">
                      <b-col class="p-0">
                        <b-form-group>
                          <b-form-radio-group
                            v-model="form.edoccob"
                            :options="this.$parent.optionsEdoccob"
                            name="edoccob"
                            plain
                            stacked
                            value-field="value"
                          ></b-form-radio-group>
                        </b-form-group>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('edoccob')"
                          v-if="form.errors.has('edoccob')"
                        ></b-form-feedback>
                      </b-col>
                    </td>
                    <td class="p-0">
                      <b-col class="p-0">
                        <multiselect
                          v-model="grupoEconomicoSelected"
                          :options-limit="300"
                          :limit="2"
                          :limit-text="limitText"
                          :options="optionsFornecedor"
                          track-by="value"
                          label="label"
                          id="fornecedor"
                          :hide-selected="true"
                          placeholder="Fornecedor ( Digite 3 caracteres para pesquisar )"
                          tag-placeholder="Selecionar"
                          select-label="Selecionar"
                          selected-label="Selecionado"
                          deselect-label="Remover"
                          :searchable="true"
                          :loading="isLoadingFornecedor"
                          @search-change="listaFornecedor"
                        ></multiselect>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('pessoa_id_grupo')"
                          v-if="form.errors.has('pessoa_id_grupo')"
                        ></b-form-feedback>
                      </b-col>
                    </td>
                    <td class="p-0">
                      <b-col class="p-0">
                        <b-form-group>
                          <b-form-radio-group
                            v-model="form.prazo_edoccob"
                            :options="this.$parent.optionsPrazoEdoccob"
                            name="prazo_edoccob"
                            plain
                            stacked
                            value-field="value"
                          ></b-form-radio-group>
                        </b-form-group>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('prazo_edoccob')"
                          v-if="form.errors.has('prazo_edoccob')"
                        ></b-form-feedback>
                      </b-col>
                    </td>
                    <td class="p-0">
                      <b-col class="p-0">
                        <b-form-group>
                          <b-form-input
                            type="number"
                            placeholder="Quantidade de reentrega"
                            v-model="form.qtde_reentrega"
                            name="qtde_reentrega"
                          >
                          </b-form-input>
                        </b-form-group>
                        <b-form-feedback
                          class="text-danger"
                          v-text="form.errors.get('qtde_reentrega')"
                          v-if="form.errors.has('qtde_reentrega')"
                        ></b-form-feedback>
                      </b-col>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="table table-striped" style="width: 25%" v-if="form.fornecedor == 1">
                <thead>
                  <tr class="bg-blue-grey bg-lighten-5">
                    <th style="width: 15%">Doc. Pagamento</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style="display: table-row">
                    <td class="p-0">
                      <b-col class="p-0">
                        <multiselect
                          v-model="docPagamentoSelected"
                          :options="this.$parent.optionsDocPagamento"
                          track-by="value"
                          label="label"
                          :hide-selected="true"
                          placeholder="Selecione"
                          tag-placeholder=""
                          select-label=""
                          selected-label="Selecionado"
                          deselect-label="Remover"
                        ></multiselect>
                        <b-form-feedback
                            class="text-danger"
                            v-text="form.errors.get('doc_pagamento')"
                            v-if="form.errors.has('doc_pagamento')"
                        ></b-form-feedback>
                      </b-col>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-tab>
          </b-tabs>
        </b-row>
      </b-container>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
        <spinner v-if="loadingCep" message="buscando endereço..."></spinner>
      </div>

      <div class="float-right">
        <div class="float-left" v-if="this.errors_array.length > 0">
          <b-btn
            class="badge badge-warning"
            @click="showPopover = !showPopover"
            id="popoverButton-sync"
            v-b-tooltip.hover.left="'Clique aqui para ver os erros encontrados'"
            variant="warning"
            ><i class="fa fa-exclamation-triangle fa-2x"></i
          ></b-btn>

          <b-popover
            :show.sync="showPopover"
            target="popoverButton-sync"
            placement="leftbottom"
          >
          <template #title>
            <strong>Erros Encontrados</strong>
          </template>
            <table class="table" id="mais">
              <tbody>
                <tr
                  class="bg-gray-light"
                  style="display: table-row"
                  v-for="item in this.errors_array"
                >
                  <td>
                    {{ item.erro }}
                  </td>
                </tr>
              </tbody>
            </table>
          </b-popover>
        </div>
        &nbsp;
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="secondary"
          :disabled="isDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import moment from "moment";
import {
  FORNECEDOR_SIM,
  FORNECEDOR_SIM_BANNER,
  FORNECEDOR_SIM_SUBMIT_ERROR,
  FORNECEDOR_SIM_TOOLTIP,
  getPlataformaLogisticaUrl,
} from "../constants/fornecedorPlataforma";

import { formatCNPJFromParts } from "../utils";

export default {
  components: {},
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      fornecedorValorOriginal: null,
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showPopover: false,
      loadingCep: false,
      isLoadingFornecedor: false,
      mascaraDoc: "###.###.###-##",
      mascaraCPF: "###.###.###-##",
      mascaraRG: "##.###.###-#",
      mascaraCNPJ: "XX.XXX.XXX/XXXX-XX",
      statusSelected: [],
      tipoPessoaSelected: [],
      ieSelected: [],
      vipNacionalSelected: [],
      vipInternacionalSelected: [],
      fornecedorSelected: [],
      grupoEconomicoSelected: [],
      categoriaSelected: [],
      ufEmissaoSelected: [],
      municipioSelected: [],
      enderecoMunicipioSelected: [],
      paramEnderecoSelected: [],
      activateDesativate: [],
      indieSelected: [],
      cnaeSelected: [],
      docPagamentoSelected: [],
      tpProprietarioSelected: [],
      tpFornecedorSelected: [],
      paramCategoriaCfopSelected: [],
      errors_array: [],
      optionsMunicipio: [],
      optionsLivStatusFinanceiro: [],
      optionsFormaPag: [],
      optionsParamBanco: [],
      optionsTpConta: [],
      optionsParamRelacionamento: [],
      optionsLivStatusReferencia: [],
      relacionamentoSelected: [],
      ufRgSelected: [],
      naturalidadeSelected: [],
      optionsFornecedor: [],
      nacionalidadeSelected: [],
      tpSituacaoResidenciaSelected: [],
      paramEstadoCivilSelected: [],
      paramOcupacaoSelected: [],
      optionsParTpEma: [],
      optionsLivContatoEmailStatus: [],
      optionsLivTipoTel: [],
      optionsGerarPreFatura: [],
      optionsStatusVendaServico: [],
      optionsControlaDtEntrega: [],
      optionsLivSimplesNacional: [],
      optionsLivPedagioBaseCalculoIcms: [],
      optionsLivCreditoPresumido: [],
      optionsOperadora: [],
      optionsLivStatusTel: [],
      optionsParEnd: [],
      pessoa_endereco: [],
      pessoa_referencia: [],
      pessoa_contato_email: [],
      pessoa_contato_tel: [],
      pessoa_financeiro: [],
      pessoa_motorista: {},
      pessoa_fisica: {
        nome: "",
        nome_pai: "",
        nome_mae: "",
        sexo: 1,
      },
      pessoa_outros: {
        nome: "",
      },
      pessoa_juridica: {
        nome_fantasia: "",
        razao_social: "",
        inscricao_estadual: "ola",
        inscricao_suframa: "",
        inscricao_municipal: "",
      },
      helpForm: new Form({
        statusRecord: [],
        params: [],
        cep_busca: "",
        pessoa_id: "",
        search: "",
      }),
      form: new Form({
        cd: "",
        cd_erp: "",
        antt: "",
        dt_validade_antt: "",
        tipo_cadastro: 1,
        obs: "",
        cnae_id: "",
        partipppt_id: "",
        parcatcfo_id: "",
        doc_pagamento: "",
        tp_fornecedor: 1,
        indie: "",
        status: "",
        fornecedor: 2,
        vip_nacional: 2,
        vip_internacional: 2,
        exige_averbacao: 1,
        valida_opentech: 1,
        tp_vinculo_ajudante: "",
        gerar_pre_fatura: 2,
        status_venda_servico: 2,
        retira: 2,
        permitir_adiantamento: 2,
        edoccob: 3,
        pessoa_id_grupo: "",
        controla_dt_entrega: 2,
        simples_nacional: 2,
        credito_presumido: 2,
        pedagio_base_calculo_icms: 2,
        cnpj: "",
        razao_social: "",
        nome_fantasia: "",
        inscricao_estadual: "",
        inscricao_municipal: "",
        inscricao_suframa: "",
        cd_regime_tributario: "",
        agencia: "",
        tipo_pessoa: "",
        agencia_nome: "",
        agencia_digito: "",
        banco: "",
        banco_nome: "",
        conta_corrente: "",
        conta_corrente_digito: "",
        metodo_pagamento: "",
        metodo_pagamento_desc: "",
        numero_acc: "",
        prazo_pagamento: "",
        pefin_id: "",
        cuit: "",
        nome: "",
        cpf: "",
        identidade: "",
        dt_emissao_cpf: "",
        dt_nascto: "",
        dt_inicio_residencia: "",
        tp_situacao_residencia: "",
        cd_pais: "",
        pessoa_endereco: [],
        pessoa_referencia: [],
        pessoa_contato_tel: [],
        pessoa_contato_email: [],
        pessoa_financeiro: [],
        pessoa_motorista: {},
        pessoa_outros: {},
        pessoa_fisica: {},
        pessoa_juridica: {},
        pessoa_id: "",
        tp_montagem_carga_portal: "",
        envio_email_parceiro: "",
        prazo_edoccob: "",
        betilay_id: "",
        qtde_reentrega: "",
      }),

      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "cd",
          title: "Código",
          sortField: "cd",
        },
        {
          name: "descr",
          title: "Descrição",
          sortField: "descr",
        },
        {
          name: "__slot:status",
          title: "Status",
          sortField: "status",
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      fornecedorBannerMessage: FORNECEDOR_SIM_BANNER,
      fornecedorTooltipMessage: FORNECEDOR_SIM_TOOLTIP,
      moreParams: {},
    };
  },
  watch: {
    indieSelected(obj) {
      this.form.indie = obj.value;
    },
    cnaeSelected(obj) {
      this.form.cnae_id = obj.value;
    },
    paramCategoriaCfopSelected(obj) {
      this.form.parcatcfo_id = obj.value;
    },
    categoriaSelected(obj) {
      this.pessoa_motorista.categoria = obj.value;
    },
    ufEmissaoSelected(obj) {
      this.pessoa_motorista.uf_id_emissao = obj.value;
    },
    tpProprietarioSelected(obj) {
      this.form.partipppt_id = obj.value;
    },
    tpFornecedorSelected(obj) {
      this.form.tp_fornecedor = obj.value;
    },
    tpSituacaoResidenciaSelected(obj) {
      this.pessoa_fisica.tp_situacao_residencia = obj.value;
    },
    paramOcupacaoSelected(obj) {
      this.pessoa_fisica.parocupa_id = obj.value;
    },
    paramEstadoCivilSelected(obj) {
      this.pessoa_fisica.parestciv_id = obj.value;
    },
    relacionamentoSelected(obj) {
      this.pessoa_fisica.parrel_id = obj.value;
    },
    ufRgSelected(obj) {
      this.pessoa_fisica.uf_id_identidade = obj.value;
    },
    naturalidadeSelected(obj) {
      this.pessoa_fisica.municipio_id = obj.value;
    },
    nacionalidadeSelected(obj) {
      this.pessoa_fisica.parnac_id = obj.value;
    },
    grupoEconomicoSelected(obj) {
      this.form.pessoa_id_grupo = obj.value;
    },
    docPagamentoSelected(obj) {
      this.form.doc_pagamento = obj.value;
    },
    pessoa_fisica: {
      deep: true,
      handler() {
        this.sanitizePessoaFisicaFields();
      },
    },
    pessoa_outros: {
      deep: true,
      handler() {
        this.sanitizePessoaOutrosFields();
      },
    },
    pessoa_juridica: {
      deep: true,
      handler() {
        this.sanitizePessoaJuridicaFields();
      },
    },
    pessoa_referencia: {
      deep: true,
      handler() {
        this.sanitizePessoaReferenciaFields();
      },
    },
    pessoa_endereco: {
      deep: true,
      handler() {
        this.sanitizePessoaEnderecoFields();
      },
    },
    pessoa_contato_tel: {
      deep: true,
      handler() {
        this.sanitizePessoaContatoTelFields();
      },
    },
    pessoa_contato_email: {
      deep: true,
      handler() {
        this.sanitizePessoaContatoEmailFields();
      },
    },
  },
  mounted() {},
  methods: {
    getRawInputValue(value) {
      if (value === undefined || value === null) {
        return "";
      }

      if (typeof value === "object") {
        if (value && value.target && value.target.value !== undefined) {
          return value.target.value;
        }
        if (value && value.value !== undefined) {
          return value.value;
        }
      }

      return value;
    },
    sanitizeTextOnDemand(value) {
      const rawValue = this.getRawInputValue(value);
      if (rawValue === undefined || rawValue === null) {
        return "";
      }

      return rawValue
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toUpperCase()
        .replace(/[^A-Z0-9\s]/g, "")
        .replace(/\s+/g, " ")
        .replace(/^\s+/, "");
    },
    sanitizeOnlyDigits(value, maxLength) {
      const rawValue = this.getRawInputValue(value);
      if (rawValue === undefined || rawValue === null) {
        return "";
      }

      return rawValue
        .toString()
        .replace(/\D/g, "")
        .slice(0, maxLength);
    },
    sanitizeCnpjAlfanumerico(value) {
      const rawValue = this.getRawInputValue(value);
      if (rawValue === undefined || rawValue === null) {
        return "";
      }

      return rawValue
        .toString()
        .replace(/[^a-zA-Z0-9]/g, "")
        .toUpperCase()
        .slice(0, 14);
    },
    sanitizeEmail(value) {
      const rawValue = this.getRawInputValue(value);
      if (rawValue === undefined || rawValue === null) {
        return "";
      }

      return rawValue
        .toString()
        .trim()
        .replace(/\s+/g, "")
        .toLowerCase();
    },
    isValidEmail(value) {
      if (!value) {
        return true;
      }

      return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value);
    },
    getEmailFieldState(value) {
      if (!value) {
        return null;
      }

      return this.isValidEmail(this.sanitizeEmail(value));
    },
    sanitizePessoaFisicaFields() {
      if (!this.pessoa_fisica) {
        return;
      }

      const nome = this.sanitizeTextOnDemand(this.pessoa_fisica.nome);
      const nomePai = this.sanitizeTextOnDemand(this.pessoa_fisica.nome_pai);
      const nomeMae = this.sanitizeTextOnDemand(this.pessoa_fisica.nome_mae);

      if (this.pessoa_fisica.nome !== nome) {
        this.pessoa_fisica.nome = nome;
      }
      if (this.pessoa_fisica.nome_pai !== nomePai) {
        this.pessoa_fisica.nome_pai = nomePai;
      }
      if (this.pessoa_fisica.nome_mae !== nomeMae) {
        this.pessoa_fisica.nome_mae = nomeMae;
      }
    },
    sanitizePessoaOutrosFields() {
      if (!this.pessoa_outros) {
        return;
      }

      const nome = this.sanitizeTextOnDemand(this.pessoa_outros.nome);
      if (this.pessoa_outros.nome !== nome) {
        this.pessoa_outros.nome = nome;
      }
    },
    sanitizePessoaJuridicaFields() {
      if (!this.pessoa_juridica) {
        return;
      }

      const nomeFantasia = this.sanitizeTextOnDemand(
        this.pessoa_juridica.nome_fantasia
      );
      const razaoSocial = this.sanitizeTextOnDemand(
        this.pessoa_juridica.razao_social
      );

      if (this.pessoa_juridica.nome_fantasia !== nomeFantasia) {
        this.pessoa_juridica.nome_fantasia = nomeFantasia;
      }
      if (this.pessoa_juridica.razao_social !== razaoSocial) {
        this.pessoa_juridica.razao_social = razaoSocial;
      }
    },
    sanitizePessoaReferenciaFields() {
      if (!Array.isArray(this.pessoa_referencia)) {
        return;
      }

      this.pessoa_referencia.forEach((item) => {
        if (!item) {
          return;
        }

        const nome = this.sanitizeTextOnDemand(item.nome);
        const ddd = this.sanitizeOnlyDigits(item.ddd, 2);
        const numeroTel = this.sanitizeOnlyDigits(item.numero_tel, 9);
        const ddd2 = this.sanitizeOnlyDigits(item.ddd_2, 2);
        const numero2 = this.sanitizeOnlyDigits(item.numero_2, 9);
        const email = this.sanitizeEmail(item.email);

        if (item.nome !== nome) {
          item.nome = nome;
        }
        if (item.ddd !== ddd) {
          item.ddd = ddd;
        }
        if (item.numero_tel !== numeroTel) {
          item.numero_tel = numeroTel;
        }
        if (item.ddd_2 !== ddd2) {
          item.ddd_2 = ddd2;
        }
        if (item.numero_2 !== numero2) {
          item.numero_2 = numero2;
        }
        if (item.email !== email) {
          item.email = email;
        }
      });
    },
    sanitizePessoaEnderecoFields() {
      if (!Array.isArray(this.pessoa_endereco)) {
        return;
      }

      this.pessoa_endereco.forEach((item) => {
        if (!item) {
          return;
        }

        const ddd = this.sanitizeOnlyDigits(item.ddd, 2);
        const numeroTel = this.sanitizeOnlyDigits(item.numero_tel, 9);
        const ddd2 = this.sanitizeOnlyDigits(item.ddd_2, 2);
        const numero2 = this.sanitizeOnlyDigits(item.numero_2, 9);

        if (item.ddd !== ddd) {
          item.ddd = ddd;
        }
        if (item.numero_tel !== numeroTel) {
          item.numero_tel = numeroTel;
        }
        if (item.ddd_2 !== ddd2) {
          item.ddd_2 = ddd2;
        }
        if (item.numero_2 !== numero2) {
          item.numero_2 = numero2;
        }
      });
    },
    sanitizePessoaContatoTelFields() {
      if (!Array.isArray(this.pessoa_contato_tel)) {
        return;
      }

      this.pessoa_contato_tel.forEach((item) => {
        if (!item) {
          return;
        }

        const ddd = this.sanitizeOnlyDigits(item.ddd, 2);
        const telefone = this.sanitizeOnlyDigits(item.telefone, 9);

        if (item.ddd !== ddd) {
          item.ddd = ddd;
        }
        if (item.telefone !== telefone) {
          item.telefone = telefone;
        }
      });
    },
    sanitizePessoaContatoEmailFields() {
      if (!Array.isArray(this.pessoa_contato_email)) {
        return;
      }

      this.pessoa_contato_email.forEach((item) => {
        if (!item) {
          return;
        }

        const email = this.sanitizeEmail(item.email);
        if (item.email !== email) {
          item.email = email;
        }
      });
    },
    validateFornecedorFieldBeforeSubmit() {
      if (Number(this.form.fornecedor) === FORNECEDOR_SIM) {
        this.errors_array = [{ erro: FORNECEDOR_SIM_SUBMIT_ERROR }];
        return false;
      }

      if (
        this.modal_acao !== "i" &&
        Number(this.fornecedorValorOriginal) === FORNECEDOR_SIM &&
        Number(this.form.fornecedor) !== FORNECEDOR_SIM
      ) {
        this.errors_array = [{ erro: FORNECEDOR_SIM_SUBMIT_ERROR }];
        return false;
      }

      return true;
    },
    validateEmailsBeforeSubmit() {
      const clientErrors = {};

      if (Array.isArray(this.pessoa_referencia)) {
        this.pessoa_referencia.forEach((item, index) => {
          if (!item) {
            return;
          }

          const email = this.sanitizeEmail(item.email);
          item.email = email;

          if (email && !this.isValidEmail(email)) {
            clientErrors["pessoa_referencia." + index + ".email"] = [
              "E-mail inválido. Exemplo: usuario@dominio.com ou usuario@dominio.com.br",
            ];
          }
        });
      }

      if (Array.isArray(this.pessoa_contato_email)) {
        this.pessoa_contato_email.forEach((item, index) => {
          if (!item) {
            return;
          }

          const email = this.sanitizeEmail(item.email);
          item.email = email;

          if (email && !this.isValidEmail(email)) {
            clientErrors["pessoa_contato_email." + index + ".email"] = [
              "E-mail inválido. Exemplo: usuario@dominio.com ou usuario@dominio.com.br",
            ];
          }
        });
      }

      if (Object.keys(clientErrors).length > 0) {
        this.form.errors.record(clientErrors);
        return false;
      }

      return true;
    },
    sanitizePhoneFieldsBeforeSubmit() {
      this.sanitizePessoaReferenciaFields();
      this.sanitizePessoaContatoTelFields();
      this.sanitizePessoaEnderecoFields();
    },
    preparePessoaPayloadByTipo() {
      this.sanitizePessoaFisicaFields();
      this.sanitizePessoaJuridicaFields();
      this.sanitizePessoaOutrosFields();

      const tipoPessoa = Number(this.form.tipo_pessoa);

      this.form.pessoa_fisica = {};
      this.form.pessoa_juridica = {};
      this.form.pessoa_outros = {};
      this.form.pessoa_motorista = {};

      if (tipoPessoa === 1) {
        this.form.pessoa_fisica = this.pessoa_fisica || {};
        this.form.pessoa_motorista = this.pessoa_motorista || {};
      }

      if (tipoPessoa === 2) {
        this.form.pessoa_juridica = this.pessoa_juridica || {};
      }

      if (tipoPessoa === 3) {
        this.form.pessoa_outros = this.pessoa_outros || {};
      }
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.pessoa_id);
      }
    },
    onCreate() {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.fornecedorValorOriginal = null;
      this.form.reset();
      this.optionsTpConta = [];
      this.optionsParTpEma = [];
      this.optionsLivTipoTel = [];
      this.optionsGerarPreFatura = [];
      this.docPagamentoSelected = [];
      this.optionsStatusVendaServico = [];
      this.optionsControlaDtEntrega = [];
      this.optionsLivSimplesNacional = [];
      this.optionsLivCreditoPresumido = [];
      this.optionsLivPedagioBaseCalculoIcms = [];
      this.optionsOperadora = [];
      this.optionsLivStatusTel = [];
      this.optionsLivContatoEmailStatus = [];
      this.optionsParamBanco = [];
      this.optionsFormaPag = [];
      this.optionsLivStatusFinanceiro = [];
      this.optionsMunicipio = [];
      this.optionsParEnd = [];
      this.optionsParamRelacionamento = [];
      this.optionsLivStatusReferencia = [];
      this.grupoEconomicoSelected = [];
      this.pessoa_contato_email = "";
      this.pessoa_contato_email = [];
      this.pessoa_contato_tel = "";
      this.pessoa_contato_tel = [];
      this.form.fornecedor = 2;
      this.form.vip_nacional = 2;
      this.form.exige_pre_fatura = 2;
      this.form.controla_dt_entrega = 2;
      this.form.simples_nacional = 2;
      this.form.credito_presumido = 2;
      this.form.pedagio_base_calculo_icms = 2;
      this.form.vip_internacional = 2;
      this.form.gerar_pre_fatura = 2;
      this.form.status_venda_servico = 2;
      this.form.permitir_adiantamento = 2;
      this.form.exige_averbacao = 1;
      this.form.valida_opentech = 1;
      this.form.tp_vinculo_ajudante ="";
      this.form.tipo_pessoa = 1;
      this.form.tp_montagem_carga_portal = 3;
      this.form.envio_email_parceiro = 3;
      this.form.edoccob = 3;
      this.form.retira = 2;
      this.form.status = 1;
      this.pessoa_endereco = [];
      this.pessoa_referencia = [];
      this.pessoa_financeiro = [];
      this.pessoa_motorista = { status: 1 };
      this.pessoa_fisica = {
        nome: "",
        nome_pai: "",
        nome_mae: "",
        sexo: 1,
      };
      this.pessoa_juridica = {
        nome_fantasia: "",
        razao_social: "",
        inscricao_estadual: "",
        inscricao_suframa: "",
        inscricao_municipal: "",
      };
      this.pessoa_outros = {
        nome: "",
      };
      this.pessoa_exterior = {};
      this.indieSelected = [];
      this.categoriaSelected = [];
      this.ufEmissaoSelected = [];
      this.cnaeSelected = [];
      this.paramCategoriaCfopSelected = [];
      this.tpProprietarioSelected = [];
      this.tpSituacaoResidenciaSelected = [];
      this.paramEstadoCivilSelected = [];
      this.paramOcupacaoSelected = [];
      this.relacionamentoSelected = [];
      this.docPagamentoSelected = [];
      this.ufRgSelected = [];
      this.naturalidadeSelected = [];
      this.nacionalidadeSelected = [];
      this.tpFornecedorSelected = { label: "Não definido", value: 1 };
      this.errors_array = "";
      this.errors_array = [];
      //qnd o options esta dentro de um array, precisa ser instanciado aqui
      this.$parent.optionsParTpEma.forEach((obj) => {
        this.optionsParTpEma.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsLivTipoTel.forEach((obj) => {
        this.optionsLivTipoTel.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsTpConta.forEach((obj) => {
        this.optionsTpConta.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsOperadora.forEach((obj) => {
        this.optionsOperadora.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsLivStatusTel.forEach((obj) => {
        this.optionsLivStatusTel.push({ text: obj.text, value: obj.value });
      });
      this.$parent.optionsLivContatoEmailStatus.forEach((obj) => {
        this.optionsLivContatoEmailStatus.push({
          text: obj.text,
          value: obj.value,
        });
      });
      this.$parent.optionsParamBanco.forEach((obj) => {
        this.optionsParamBanco.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsFormaPag.forEach((obj) => {
        this.optionsFormaPag.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsLivStatusFinanceiro.forEach((obj) => {
        this.optionsLivStatusFinanceiro.push({
          text: obj.text,
          value: obj.value,
        });
      });
      this.$parent.optionsMunicipio.forEach((obj) => {
        this.optionsMunicipio.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsParEnd.forEach((obj) => {
        this.optionsParEnd.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsParamRelacionamento.forEach((obj) => {
        this.optionsParamRelacionamento.push({
          label: obj.label,
          value: obj.value,
        });
      });
      this.$parent.optionsLivStatusFinanceiro.forEach((obj) => {
        this.optionsLivStatusReferencia.push({
          text: obj.text,
          value: obj.value,
        });
      });
      this.$parent.optionsGerarPreFatura.forEach((obj) => {
        this.optionsGerarPreFatura.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsStatusVendaServico.forEach((obj) => {
        this.optionsStatusVendaServico.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsControlaDtEntrega.forEach((obj) => {
        this.optionsControlaDtEntrega.push({
          label: obj.label,
          value: obj.value,
        });
      });
      this.$parent.optionsLivSimplesNacional.forEach((obj) => {
        this.optionsLivSimplesNacional.push({
          label: obj.label,
          value: obj.value,
        });
      });
      this.$parent.optionsLivCreditoPresumido.forEach((obj) => {
        this.optionsLivCreditoPresumido.push({
          label: obj.label,
          value: obj.value,
        });
      });
      this.$parent.optionsLivPedagioBaseCalculoIcms.forEach((obj) => {
        this.optionsLivPedagioBaseCalculoIcms.push({
          label: obj.label,
          value: obj.value,
        });
      });
      this.$refs.modal_form.show();
    },
    onEdit(data, index) {
      this.isDisabled = false;
      this.loading = false;
      this.fornecedorValorOriginal = null;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      if (data.cd == null) {
        this.modal_acao = "uc";
      } else {
        this.modal_acao = "u";
      }
      this.optionsParTpEma = [];
      this.optionsLivTipoTel = [];
      this.optionsControlaDtEntrega = [];
      this.optionsGerarPreFatura = [];
      this.optionsStatusVendaServico = [];
      this.optionsOperadora = [];
      this.optionsLivStatusTel = [];
      this.optionsLivContatoEmailStatus = [];
      this.optionsParamBanco = [];
      this.docPagamentoSelected = [];
      this.optionsFormaPag = [];
      this.optionsLivStatusFinanceiro = [];
      this.optionsMunicipio = [];
      this.optionsParEnd = [];
      this.optionsParamRelacionamento = [];
      this.optionsLivStatusReferencia = [];
      this.grupoEconomicoSelected = [];
      this.pessoa_contato_email = [];
      this.optionsTpConta = [];
      this.pessoa_contato_tel = [];
      this.pessoa_endereco = [];
      this.pessoa_referencia = [];
      this.pessoa_financeiro = [];
      this.tpProprietarioSelected = [];
      this.tpFornecedorSelected = [];
      this.docPagamentoSelected = [];
      this.tpSituacaoResidenciaSelected = [];
      this.categoriaSelected = [];
      this.paramOcupacaoSelected = [];
      this.paramEstadoCivilSelected = [];
      this.relacionamentoSelected = [];
      this.ufRgSelected = [];
      this.naturalidadeSelected = [];
      this.nacionalidadeSelected = [];
      this.pessoa_motorista = {};
      this.pessoa_fisica = {
        nome: "",
        nome_pai: "",
        nome_mae: "",
        sexo: 1,
      };
      this.pessoa_juridica = {
        nome_fantasia: "",
        razao_social: "",
        inscricao_estadual: "",
        inscricao_suframa: "",
        inscricao_municipal: "",
      };
      this.pessoa_outros = {
        nome: "",
      };
      this.pessoa_exterior = {};
      this.errors_array = "";
      this.errors_array = [];

      // Carregando arrays de opções
      this.$parent.optionsParTpEma.forEach((obj) => {
        this.optionsParTpEma.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsLivTipoTel.forEach((obj) => {
        this.optionsLivTipoTel.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsOperadora.forEach((obj) => {
        this.optionsOperadora.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsLivStatusTel.forEach((obj) => {
        this.optionsLivStatusTel.push({ text: obj.text, value: obj.value });
      });
      this.$parent.optionsLivContatoEmailStatus.forEach((obj) => {
        this.optionsLivContatoEmailStatus.push({ text: obj.text, value: obj.value });
      });
      this.$parent.optionsTpConta.forEach((obj) => {
        this.optionsTpConta.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsParamBanco.forEach((obj) => {
        this.optionsParamBanco.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsFormaPag.forEach((obj) => {
        this.optionsFormaPag.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsLivStatusFinanceiro.forEach((obj) => {
        this.optionsLivStatusFinanceiro.push({ text: obj.text, value: obj.value });
      });
      this.$parent.optionsMunicipio.forEach((obj) => {
        this.optionsMunicipio.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsParEnd.forEach((obj) => {
        this.optionsParEnd.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsParamRelacionamento.forEach((obj) => {
        this.optionsParamRelacionamento.push({ label: obj.label, value: obj.value });
      });
      this.$parent.optionsLivStatusFinanceiro.forEach((obj) => {
        this.optionsLivStatusReferencia.push({ text: obj.text, value: obj.value });
      });
      this.$parent.optionsGerarPreFatura.forEach((obj) => {
        this.optionsGerarPreFatura.push({ text: obj.label, value: obj.value });
      });
      this.$parent.optionsStatusVendaServico.forEach((obj) => {
        this.optionsStatusVendaServico.push({ text: obj.label, value: obj.value });
      });
      this.$parent.optionsControlaDtEntrega.forEach((obj) => {
        this.optionsControlaDtEntrega.push({ text: obj.label, value: obj.value });
      });
      this.$parent.optionsLivSimplesNacional.forEach((obj) => {
        this.optionsLivSimplesNacional.push({ text: obj.label, value: obj.value });
      });
      this.$parent.optionsLivPedagioBaseCalculoIcms.forEach((obj) => {
        this.optionsLivPedagioBaseCalculoIcms.push({ text: obj.label, value: obj.value });
      });
      this.$parent.optionsLivCreditoPresumido.forEach((obj) => {
        this.optionsLivCreditoPresumido.push({ text: obj.label, value: obj.value });
      });

      this.form.reset();
      this.form.cd = data.cd;
      this.form.cd_erp = data.cd_erp;
      this.form.antt = data.antt;
      this.form.dt_validade_antt = data.dt_validade_antt;
      this.form.obs = data.obs;

      if (data.tp_montagem_carga_portal && data.tp_montagem_carga_portal.valor != null) {
        this.form.tp_montagem_carga_portal = data.tp_montagem_carga_portal.valor;
      }

      if (data.envio_email_parceiro && data.envio_email_parceiro.valor != null) {
        this.form.envio_email_parceiro = data.envio_email_parceiro.valor;
      }

      this.form.qtde_reentrega = data.qtde_reentrega;

      if (data.pessoa_fisica_grupo_economico) {
        this.grupoEconomicoSelected = {
          label: data.pessoa_fisica_grupo_economico.nome,
          value: data.pessoa_fisica_grupo_economico.pessoa_id,
        };
      }
      if (data.pessoa_juridica_grupo_economico) {
        this.grupoEconomicoSelected = {
          label: data.pessoa_juridica_grupo_economico.razao_social,
          value: data.pessoa_juridica_grupo_economico.pessoa_id,
        };
      }
      if (data.pessoa_exterior_grupo_economico) {
        this.grupoEconomicoSelected = {
          label: data.pessoa_exterior_grupo_economico.nome,
          value: data.pessoa_exterior_grupo_economico.pessoa_id,
        };
      }
      if (data.cnae) {
        this.cnaeSelected = { label: data.cnae.cd + " - " + data.cnae.descr, value: data.cnae.cnae_id };
      } else {
        this.cnaeSelected = [];
      }
      if (data.param_categoria_cfop) {
        this.paramCategoriaCfopSelected = {
          label: data.param_categoria_cfop.cd + " - " + data.param_categoria_cfop.descr,
          value: data.param_categoria_cfop.parcatcfo_id,
        };
      }
      if (data.param_tipo_proprietario) {
        this.tpProprietarioSelected = {
          label: data.param_tipo_proprietario.descr,
          value: data.param_tipo_proprietario.partipppt_id,
        };
      }
      if (data.liv_tp_fornecedor) {
        this.tpFornecedorSelected = {
          label: data.liv_tp_fornecedor.descr,
          value: data.liv_tp_fornecedor.valor,
        };
      }
      if (data.liv_tipo_pessoa) {
        this.form.tipo_pessoa = data.liv_tipo_pessoa.valor;
      }
      if (data.liv_indie) {
        this.indieSelected = { label: data.liv_indie.descr, value: data.liv_indie.valor };
      }

      if (data.status && data.status.valor != null) {
        this.form.status = data.status.valor;
      }
      if (data.liv_fornecedor && data.liv_fornecedor.valor != null) {
        this.form.fornecedor = data.liv_fornecedor.valor;
        this.fornecedorValorOriginal = data.liv_fornecedor.valor;
      }
      if (data.liv_vip_nacional && data.liv_vip_nacional.valor != null) {
        this.form.vip_nacional = data.liv_vip_nacional.valor;
      }
      if (data.liv_vip_internacional && data.liv_vip_internacional.valor != null) {
        this.form.vip_internacional = data.liv_vip_internacional.valor;
      }
      if (data.exige_averbacao && data.exige_averbacao.valor != null) {
        this.form.exige_averbacao = data.exige_averbacao.valor;
      }
      if (data.valida_opentech && data.valida_opentech.valor != null) {
        this.form.valida_opentech = data.valida_opentech.valor;
      }

      if (data.pessoa_ajudante && data.pessoa_ajudante.tp_vinculo) {
        this.form.tp_vinculo_ajudante = data.pessoa_ajudante.tp_vinculo.valor;
      }

      if (data.liv_gerar_pre_fatura && data.liv_gerar_pre_fatura.valor != null) {
        this.form.gerar_pre_fatura = data.liv_gerar_pre_fatura.valor;
      }
      if (data.status_venda_servico && data.status_venda_servico.valor != null) {
        this.form.status_venda_servico = data.status_venda_servico.valor;
      }
      if (data.prazo_edoccob && data.prazo_edoccob.valor != null) {
        this.form.prazo_edoccob = data.prazo_edoccob.valor;
      }
      if (data.permitir_adiantamento && data.permitir_adiantamento.valor != null) {
        this.form.permitir_adiantamento = data.permitir_adiantamento.valor;
      }
      if (data.b_etiqueta_layout) {
        this.form.betilay_id = data.b_etiqueta_layout.betilay_id;
      }
      if (data.edoccob && data.edoccob.valor != null) {
        this.form.edoccob = data.edoccob.valor;
      }
      if (data.retira && data.retira.valor != null) {
        this.form.retira = data.retira.valor;
      }
      if (data.liv_controla_dt_entrega && data.liv_controla_dt_entrega.valor != null) {
        this.form.controla_dt_entrega = data.liv_controla_dt_entrega.valor;
      }
      this.form.pessoa_id = data.pessoa_id;

      if (data.doc_pagamento) {
        this.docPagamentoSelected = {
          label: data.doc_pagamento.descr,
          value: data.doc_pagamento.value,
        };
      }

      // Pessoa Física
      if (data.liv_tipo_pessoa && data.liv_tipo_pessoa.valor == 1 && data.pessoa_fisica) {
        this.pessoa_fisica.nome = data.pessoa_fisica.nome;
        this.pessoa_fisica.nome_pai = data.pessoa_fisica.nome_pai;
        this.pessoa_fisica.nome_mae = data.pessoa_fisica.nome_mae;
        this.pessoa_fisica.cpf = data.pessoa_fisica.cpf;

        if (data.pessoa_fisica.sexo && data.pessoa_fisica.sexo.valor != null) {
          this.pessoa_fisica.sexo = data.pessoa_fisica.sexo.valor;
        }

        this.pessoa_fisica.identidade = data.pessoa_fisica.identidade;
        this.pessoa_fisica.uf_id_identidade = data.pessoa_fisica.uf_id_identidade;
        this.pessoa_fisica.dt_emissao_cpf = data.pessoa_fisica.dt_emissao_cpf;
        this.pessoa_fisica.dt_nascto = data.pessoa_fisica.dt_nascto;

        if (data.pessoa_fisica.uf_identidade) {
          this.ufRgSelected = {
            label: data.pessoa_fisica.uf_identidade.cd,
            value: data.pessoa_fisica.uf_identidade.uf_id,
          };
        }

        if (data.pessoa_fisica.municipio) {
          this.naturalidadeSelected = {
            label: data.pessoa_fisica.municipio.nome,
            value: data.pessoa_fisica.municipio.municipio_id,
          };
        }

        if (data.pessoa_fisica.tp_situacao_residencia) {
          this.tpSituacaoResidenciaSelected = {
            label: data.pessoa_fisica.tp_situacao_residencia.descr,
            value: data.pessoa_fisica.tp_situacao_residencia.valor,
          };
        }

        if (data.pessoa_fisica.param_ocupacao) {
          this.paramOcupacaoSelected = {
            label: data.pessoa_fisica.param_ocupacao.descr,
            value: data.pessoa_fisica.param_ocupacao.parocupa_id,
          };
        }

        if (data.pessoa_fisica.param_estado_civil) {
          this.paramEstadoCivilSelected = {
            label: data.pessoa_fisica.param_estado_civil.descr,
            value: data.pessoa_fisica.param_estado_civil.parestciv_id,
          };
        }

        if (data.pessoa_fisica.param_nacionalidade) {
          this.nacionalidadeSelected = {
            label: data.pessoa_fisica.param_nacionalidade.descr,
            value: data.pessoa_fisica.param_nacionalidade.parnac_id,
          };
        }

        if (data.pessoa_fisica.param_relacionamento) {
          this.relacionamentoSelected = {
            label: data.pessoa_fisica.param_relacionamento.descr,
            value: data.pessoa_fisica.param_relacionamento.parrel_id,
          };
        }

        this.pessoa_fisica.dt_inicio_residencia = data.pessoa_fisica.dt_inicio_residencia;

        if (data.pessoa_fisica.pessoa_motorista) {
          this.pessoa_motorista.cnh = data.pessoa_fisica.pessoa_motorista.cnh;
          this.pessoa_motorista.pesmot_id = data.pessoa_fisica.pessoa_motorista.pesmot_id;
          this.pessoa_motorista.obs = data.pessoa_fisica.pessoa_motorista.obs;
          this.pessoa_motorista.dt_vencimento_cnh = data.pessoa_fisica.pessoa_motorista.dt_vencimento_cnh;
          this.pessoa_motorista.dt_emissao_cnh = data.pessoa_fisica.pessoa_motorista.dt_emissao_cnh;
          this.pessoa_motorista.num_registro_cnh = data.pessoa_fisica.pessoa_motorista.num_registro_cnh;

          if (data.pessoa_fisica.pessoa_motorista.tp_vinculo) {
            this.pessoa_motorista.tp_vinculo = data.pessoa_fisica.pessoa_motorista.tp_vinculo.valor;
          }

          if (data.pessoa_fisica.pessoa_motorista.status) {
            this.pessoa_motorista.status = data.pessoa_fisica.pessoa_motorista.status.valor;
          }

          if (data.pessoa_fisica.pessoa_motorista.categoria) {
            this.categoriaSelected = {
              label: data.pessoa_fisica.pessoa_motorista.categoria.descr,
              value: data.pessoa_fisica.pessoa_motorista.categoria.valor,
            };
          }

          if (data.pessoa_fisica.pessoa_motorista.uf_emissao) {
            this.ufEmissaoSelected = {
              label: data.pessoa_fisica.pessoa_motorista.uf_emissao.cd,
              value: data.pessoa_fisica.pessoa_motorista.uf_emissao.uf_id,
            };
          }
        }
      }

      // Pessoa Jurídica
      if (data.liv_tipo_pessoa && data.liv_tipo_pessoa.valor == 2 && data.pessoa_juridica) {
        const cnpjRaw = data.pessoa_juridica.cnpj
          ? data.pessoa_juridica.cnpj
          : this.onFormataCnpj(
              data.pessoa_juridica.cnpj_base,
              data.pessoa_juridica.cnpj_filial,
              data.pessoa_juridica.cnpj_digito
            );

        this.pessoa_juridica.cnpj = this.ajustaMascaraForm(
          this.sanitizeCnpjAlfanumerico(cnpjRaw)
        );
        this.pessoa_juridica.razao_social = data.pessoa_juridica.razao_social;
        this.pessoa_juridica.nome_fantasia = data.pessoa_juridica.nome_fantasia;
        this.pessoa_juridica.inscricao_estadual = data.pessoa_juridica.inscricao_estadual;
        this.pessoa_juridica.inscricao_municipal = data.pessoa_juridica.inscricao_municipal;
        this.pessoa_juridica.inscricao_suframa = data.pessoa_juridica.inscricao_suframa;
        this.pessoa_juridica.cd_regime_tributario = data.pessoa_juridica.cd_regime_tributario;

        if (data.pessoa_juridica.liv_simples_nacional) {
          this.pessoa_juridica.simples_nacional = data.pessoa_juridica.liv_simples_nacional.valor;
        }

        if (data.pessoa_juridica.liv_credito_presumido) {
          this.pessoa_juridica.credito_presumido = data.pessoa_juridica.liv_credito_presumido.valor;
        }

        if (data.pessoa_juridica.liv_pedagio_base_calculo_icms) {
          this.pessoa_juridica.pedagio_base_calculo_icms = data.pessoa_juridica.liv_pedagio_base_calculo_icms.valor;
        }
      }

      // Pessoa Exterior
      if (data.liv_tipo_pessoa && data.liv_tipo_pessoa.valor == 3 && data.pessoa_exterior) {
        this.pessoa_outros.nome = data.pessoa_exterior.nome;
        this.pessoa_outros.cuit = data.pessoa_exterior.cuit;
        this.pessoa_outros.cd_pais = data.pessoa_exterior.cd_pais;
      }

      // Pessoa Referência
      if (data.pessoa_referencia && data.pessoa_referencia.length > 0) {
        data.pessoa_referencia.forEach((obj) => {
          let municipioRef = null;
          if (obj.municipio) {
            municipioRef = { label: obj.municipio.nome, value: obj.municipio.municipio_id };
          }
          let parrelRef = null;
          if (obj.param_relacionamento) {
            parrelRef = { label: obj.param_relacionamento.descr, value: obj.param_relacionamento.parrel_id };
          }
          this.pessoa_referencia.push({
            nome: obj.nome,
            ddd: this.sanitizeOnlyDigits(obj.ddd, 2),
            numero_tel: this.sanitizeOnlyDigits(obj.numero_tel, 9),
            email: obj.email,
            ddd_2: this.sanitizeOnlyDigits(obj.ddd_2, 2),
            numero_2: this.sanitizeOnlyDigits(obj.numero_2, 9),
            cep: obj.cep,
            bairro: obj.bairro,
            endereco: obj.endereco,
            status: obj.status ? obj.status.valor : null,
            numero: obj.numero,
            pesref_id: obj.pesref_id,
            complemento: obj.complemento,
            cpf: obj.cpf,
            cargo: obj.cargo,
            dt_nascto: obj.dt_nascto,
            identidade: obj.identidade,
            orgao_identidade: obj.orgao_identidade,
            municipio: municipioRef,
            parrel: parrelRef,
          });
        });
      }

      // Pessoa Endereço
      if (data.pessoa_endereco && data.pessoa_endereco.length > 0) {
        data.pessoa_endereco.forEach((obj) => {
          let municipioEnd = null;
          if (obj.municipio) {
            municipioEnd = { label: obj.municipio.nome, value: obj.municipio.municipio_id };
          }
          let parendEnd = null;
          if (obj.parend) {
            parendEnd = { label: obj.parend.descr, value: obj.parend.parend_id };
          }
          this.pessoa_endereco.push({
            cep: obj.cep,
            bairro: obj.bairro,
            endereco: obj.endereco,
            status: obj.status ? obj.status.valor : null,
            numero: obj.numero,
            pesend_id: obj.pesend_id,
            complemento: obj.complemento,
            ddd: this.sanitizeOnlyDigits(obj.ddd, 2),
            numero_tel: this.sanitizeOnlyDigits(obj.numero_tel, 9),
            ddd_2: this.sanitizeOnlyDigits(obj.ddd_2, 2),
            numero_2: this.sanitizeOnlyDigits(obj.numero_2, 9),
            municipio: municipioEnd,
            is_padrao: obj.is_padrao ? obj.is_padrao.valor : null,
            parend: parendEnd,
          });
        });
      }

      // Pessoa Contato Email
      if (data.pessoa_contato_email && data.pessoa_contato_email.length > 0) {
        data.pessoa_contato_email.forEach((obj) => {
          let partpemaEmail = null;
          if (obj.param_tipo_email) {
            partpemaEmail = { label: obj.param_tipo_email.descr, value: obj.param_tipo_email.partpema_id };
          }
          this.pessoa_contato_email.push({
            email: obj.email,
            pesconema_id: obj.pesconema_id,
            email_default: obj.email_default ? obj.email_default.valor : null,
            status: obj.status ? obj.status.valor : null,
            partpema: partpemaEmail,
          });
        });
      }

      // Pessoa Contato Tel
      if (data.pessoa_contato_tel && data.pessoa_contato_tel.length > 0) {
        data.pessoa_contato_tel.forEach((obj) => {
          let tipoTel = null;
          if (obj.tipo_tel) {
            tipoTel = { label: obj.tipo_tel.descr, value: obj.tipo_tel.valor };
          }
          let partelopeTel = null;
          if (obj.tipo_tel) {
            partelopeTel = { label: obj.tipo_tel.descr, value: obj.tipo_tel.partelope_id };
          }
          this.pessoa_contato_tel.push({
            ddd: this.sanitizeOnlyDigits(obj.ddd, 2),
            telefone: this.sanitizeOnlyDigits(obj.telefone, 9),
            is_padrao: obj.is_padrao,
            pescontel_id: obj.pescontel_id,
            status: obj.status ? obj.status.valor : null,
            tipo_tel_det: tipoTel,
            partelope: partelopeTel,
          });
        });
      }

      // Pessoa Financeiro
      if (data.pessoa_financeiro && data.pessoa_financeiro.length > 0) {
        data.pessoa_financeiro.forEach((obj) => {
          let parbanFin = null;
          if (obj.param_banco) {
            parbanFin = { label: obj.param_banco.descr, value: obj.param_banco.parban_id };
          }
          let parforpagFin = null;
          if (obj.param_forma_pagamento) {
            parforpagFin = { label: obj.param_forma_pagamento.descr, value: obj.param_forma_pagamento.parforpag_id };
          }
          let tpContaFin = null;
          if (obj.tp_conta) {
            tpContaFin = { label: obj.tp_conta.descr, value: obj.tp_conta.valor };
          }
          this.pessoa_financeiro.push({
            agencia: obj.agencia,
            pefin_id: obj.pefin_id,
            agencia_digito: obj.agencia_digito,
            agencia_nome: obj.agencia_nome,
            conta_corrente: obj.conta_corrente,
            conta_corrente_digito: obj.conta_corrente_digito,
            numero_acc: obj.numero_acc,
            prazo_pagamento: obj.prazo_pagamento,
            obs: obj.obs,
            status: obj.status ? obj.status.valor : null,
            is_padrao: obj.is_padrao,
            parban: parbanFin,
            parforpag: parforpagFin,
            tp_conta: tpContaFin,
          });
        });
      }

      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form.tipo_cadastro = 1;

      if (!this.validateFornecedorFieldBeforeSubmit()) {
        this.loading = false;
        this.isDisabled = false;
        return;
      }

      if (!this.validateEmailsBeforeSubmit()) {
        this.loading = false;
        this.isDisabled = false;
        return;
      }
      this.sanitizePhoneFieldsBeforeSubmit();

      if (this.form.tipo_pessoa == 1) {
        if (this.pessoa_fisica.cpf !== undefined) {
          this.pessoa_fisica.cpf = this.pessoa_fisica.cpf.replace(
            /([-./])/g,
            ""
          );
        }
      }
      if (this.form.tipo_pessoa == 2) {
        if (this.pessoa_juridica.cnpj !== undefined) {
          this.pessoa_juridica.cnpj = this.sanitizeCnpjAlfanumerico(
            this.pessoa_juridica.cnpj
          );
          if (this.pessoa_juridica.inscricao_estadual === undefined) {
            this.pessoa_juridica.inscricao_estadual = "";
          }
          if (this.pessoa_juridica.inscricao_suframa === undefined) {
            this.pessoa_juridica.inscricao_suframa = "";
          }
          if (this.pessoa_juridica.inscricao_municipal === undefined) {
            this.pessoa_juridica.inscricao_municipal = "";
          }
          if (
            this.pessoa_juridica.inscricao_estadual !== "undefined" ||
            this.pessoa_juridica.inscricao_estadual != ""
          ) {
            this.pessoa_juridica.inscricao_estadual =
              this.pessoa_juridica.inscricao_estadual
                .toString()
                .replace(/([-./])/g, "");
          }
          if (this.pessoa_juridica.inscricao_suframa != "") {
            this.pessoa_juridica.inscricao_suframa =
              this.pessoa_juridica.inscricao_suframa
                .toString()
                .replace(/([-./])/g, "");
          }
          if (this.pessoa_juridica.inscricao_municipal != "") {
            this.pessoa_juridica.inscricao_municipal =
              this.pessoa_juridica.inscricao_municipal
                .toString()
                .replace(/([-./])/g, "");
          }
        }
      }
      if (this.form.tipo_pessoa == 3) {
        if (this.pessoa_outros.cuit !== undefined) {
          this.pessoa_outros.cuit = this.pessoa_outros.cuit.replace(
            /([-./])/g,
            ""
          );
        }
      }
      this.form.pessoa_contato_email = this.pessoa_contato_email;
      this.form.pessoa_contato_tel = this.pessoa_contato_tel;
      this.form.pessoa_endereco = this.pessoa_endereco;
      this.form.pessoa_referencia = this.pessoa_referencia;
      this.form.pessoa_financeiro = this.pessoa_financeiro;
      if (this.pessoa_motorista && this.pessoa_motorista.cnh != null) {
        this.pessoa_motorista.cnh = this.pessoa_motorista.cnh.toString().replace(
          /([-./])/g,
          ""
        );
      }
      this.preparePessoaPayloadByTipo();
      //ajusta os valores de array
      this.form.pessoa_endereco.forEach((item, index) => {
        if (item.municipio != null) {
          this.form.pessoa_endereco[index].municipio_id = item.municipio.value;
        }
        if (item.parend != null) {
          this.form.pessoa_endereco[index].parend_id = item.parend.value;
        }
        if (item.cep != null) {
          this.form.pessoa_endereco[index].cep = item.cep.replace("-", "");
        }
      });
      this.form.pessoa_referencia.forEach((item, index) => {
        if (item.municipio != null) {
          this.form.pessoa_referencia[index].municipio_id =
            item.municipio.value;
        }
        if (item.parrel != null) {
          this.form.pessoa_referencia[index].parrel_id = item.parrel.value;
        }
        if (item.cep != null) {
          this.form.pessoa_referencia[index].cep = item.cep.replace("-", "");
        }
        if (this.form.pessoa_referencia[index].cpf != null) {
          this.form.pessoa_referencia[index].cpf = item.cpf.replace(
            /([-./])/g,
            ""
          );
        }
        this.form.pessoa_referencia[index].dt_nascto = item.dt_nascto;
      });
      this.form.pessoa_financeiro.forEach((item, index) => {
        if (item.parforpag != null) {
          this.form.pessoa_financeiro[index].parforpag_id =
            item.parforpag.value;
        }
        if (item.parban != null) {
          this.form.pessoa_financeiro[index].parban_id = item.parban.value;
        }
        if (item.tp_conta != null) {
          this.form.pessoa_financeiro[index].tp_conta = item.tp_conta.value;
        }
      });
      this.form.pessoa_contato_email.forEach((item, index) => {
        if (item.partpema != null) {
          this.form.pessoa_contato_email[index].partpema_id =
            item.partpema.value;
        }
      });
      this.form.pessoa_contato_tel.forEach((item, index) => {
        if (item.tipo_tel_det != null) {
          this.form.pessoa_contato_tel[index].tipo_tel =
            item.tipo_tel_det.value;
        }
        if (item.partelope != null) {
          this.form.pessoa_contato_tel[index].partelope_id =
            item.partelope.value;
        }
      });

      this.form
        .put("/api/pessoa/store")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form.tipo_cadastro = 1;

      if (!this.validateFornecedorFieldBeforeSubmit()) {
        this.loading = false;
        this.isDisabled = false;
        return;
      }

      if (!this.validateEmailsBeforeSubmit()) {
        this.loading = false;
        this.isDisabled = false;
        return;
      }
      this.sanitizePhoneFieldsBeforeSubmit();

      if (this.form.tipo_pessoa == 1 && this.pessoa_fisica && this.pessoa_fisica.cpf) {
          this.pessoa_fisica.cpf = this.pessoa_fisica.cpf.replace(/([-./])/g, "");
      }

      if (this.form.tipo_pessoa == 2) {
          if (this.pessoa_juridica && this.pessoa_juridica.cnpj) {
              this.pessoa_juridica.cnpj = this.sanitizeCnpjAlfanumerico(this.pessoa_juridica.cnpj);
          }

          if (!this.pessoa_juridica.inscricao_estadual) {
              this.pessoa_juridica.inscricao_estadual = "";
          }
          if (!this.pessoa_juridica.inscricao_suframa) {
              this.pessoa_juridica.inscricao_suframa = "";
          }
          if (!this.pessoa_juridica.inscricao_municipal) {
              this.pessoa_juridica.inscricao_municipal = "";
          }

          if (this.pessoa_juridica.inscricao_estadual) {
              this.pessoa_juridica.inscricao_estadual = this.pessoa_juridica.inscricao_estadual
                  .toString()
                  .replace(/([-./])/g, "");
          }
          if (this.pessoa_juridica.inscricao_suframa) {
              this.pessoa_juridica.inscricao_suframa = this.pessoa_juridica.inscricao_suframa
                  .toString()
                  .replace(/([-./])/g, "");
          }
          if (this.pessoa_juridica.inscricao_municipal) {
              this.pessoa_juridica.inscricao_municipal = this.pessoa_juridica.inscricao_municipal
                  .toString()
                  .replace(/([-./])/g, "");
          }
      }

      if (this.form.tipo_pessoa == 3 && this.pessoa_outros && this.pessoa_outros.cuit) {
          this.pessoa_outros.cuit = this.pessoa_outros.cuit.replace(/([-./])/g, "");
      }

      this.form.pessoa_contato_email = this.pessoa_contato_email || [];
      this.form.pessoa_contato_tel = this.pessoa_contato_tel || [];
      this.form.pessoa_endereco = this.pessoa_endereco || [];
      this.form.pessoa_referencia = this.pessoa_referencia || [];
      this.form.pessoa_financeiro = this.pessoa_financeiro || [];
      this.preparePessoaPayloadByTipo();

      if (this.pessoa_motorista && this.pessoa_motorista.cnh) {
          this.form.pessoa_motorista.cnh = this.pessoa_motorista.cnh.toString().replace(/([-./])/g, "");
      }

      this.form.pessoa_endereco.forEach((item, index) => {
          if (item) {
              if (item.cep) {
                  this.form.pessoa_endereco[index].cep = item.cep.replace("-", "");
              }
              this.form.pessoa_endereco[index].municipio_id = item.municipio && item.municipio.value ? item.municipio.value : null;
              this.form.pessoa_endereco[index].parend_id = item.parend && item.parend.value ? item.parend.value : null;
          }
      });

      this.form.pessoa_referencia.forEach((item, index) => {
          if (item) {
              this.form.pessoa_referencia[index].municipio_id = item.municipio && item.municipio.value ? item.municipio.value : null;
              this.form.pessoa_referencia[index].parrel_id = item.parrel && item.parrel.value ? item.parrel.value : null;
              if (item.cep) {
                  this.form.pessoa_referencia[index].cep = item.cep.replace("-", "");
              }
              if (item.cpf) {
                  this.form.pessoa_referencia[index].cpf = item.cpf.replace(/([-./])/g, "");
              }
          }
      });

      this.form.pessoa_financeiro.forEach((item, index) => {
          if (item) {
              this.form.pessoa_financeiro[index].parforpag_id = item.parforpag && item.parforpag.value ? item.parforpag.value : null;
              this.form.pessoa_financeiro[index].parban_id = item.parban && item.parban.value ? item.parban.value : null;
              this.form.pessoa_financeiro[index].tp_conta = item.tp_conta && item.tp_conta.value ? item.tp_conta.value : null;
          }
      });

      this.form.pessoa_contato_email.forEach((item, index) => {
          if (item) {
              this.form.pessoa_contato_email[index].partpema_id = item.partpema && item.partpema.value ? item.partpema.value : null;
          }
      });

      this.form.pessoa_contato_tel.forEach((item, index) => {
          if (item) {
              this.form.pessoa_contato_tel[index].tipo_tel = item.tipo_tel_det && item.tipo_tel_det.value ? item.tipo_tel_det.value : null;
              this.form.pessoa_contato_tel[index].partelope_id = item.partelope && item.partelope.value ? item.partelope.value : null;
          }
      });

      this.form
          .patch("/api/pessoa/update/" + id)
          .then((response) => {
              new ReturnApi(response, this);
              if (this.metodo) {
                  this.metodo();
              }
          })
          .catch((errors) => {
              new ReturnApi(errors, this, true, null, null, false);
              this.errors_array = [];
              for (var property in errors) {
                  if (errors.hasOwnProperty(property) && Array.isArray(errors[property])) {
                      errors[property].forEach((obj) => {
                          this.errors_array.push({ erro: obj });
                      });
                  }
              }
          });
  },
    addRowEndereco: function (e) {
      e.preventDefault();
      this.vn_padrao = 1;
      if (this.pessoa_endereco.length > 0) {
        this.vn_padrao = 2;
      }
      this.pessoa_endereco.push({
        pesref_id: "",
        nome: "",
        ddd: "",
        numero_tel: "",
        email: "",
        parrel_id: "",
        municipio_id: "",
        pessoa_id: "",
        ddd_2: "",
        numero_2: "",
        endereco: "",
        numero: "",
        bairro: "",
        complemento: "",
        cep: "",
        status: 1,
        is_padrao: this.vn_padrao,
      });
    },
    removeRowEndereco: function (index) {
      this.pessoa_endereco.splice(index, 1);
    },
    addRowReferencia: function (e) {
      e.preventDefault();
      this.vn_padrao = 1;
      if (this.pessoa_referencia.length > 0) {
        this.vn_padrao = 2;
      }
      this.pessoa_referencia.push({
        nome: "",
        ddd: "",
        numero_tel: "",
        email: "",
        parrel: [],
        parrel_id: "",
        cpf: "",
        cargo: "",
        identidade: "",
        orgao_identidade: "",
        dt_nascto: "",
        ddd_2: "",
        numero_2: "",
        cep: "",
        bairro: "",
        endereco: "",
        numero: "",
        complemento: "",
        pesend_id: "",
        municipio: [],
        municipio_id: "",
        is_padrao: this.vn_padrao,
        parend_id: "",
        status: 1,
      });
    },
    removeRowReferencia: function (index) {
      this.pessoa_referencia.splice(index, 1);
    },
    addRowFinanceiro: function (e) {
      e.preventDefault();
      this.vn_padrao = 1;
      if (this.pessoa_financeiro.length > 0) {
        this.vn_padrao = 2;
      }
      this.pessoa_financeiro.push({
        agencia: "",
        agencia_digito: "",
        agencia_nome: "",
        parban_id: "",
        conta_corrente: "",
        conta_corrente_digito: "",
        prazo_pagamento: "",
        parforpag_id: "",
        parforpag: [],
        parban: [],
        status: 1,
        obs: "",
        is_padrao: this.vn_padrao,
      });
    },
    removeRowFinanceiro: function (index) {
      this.pessoa_financeiro.splice(index, 1);
    },
    addRowTel: function (e) {
      e.preventDefault();
      this.vn_padrao = 1;
      if (this.pessoa_contato_tel.length > 0) {
        this.vn_padrao = 2;
      }
      this.pessoa_contato_tel.push({
        ddd: "",
        telefone: "",
        tipo_tel: "",
        tipo_tel_det: [],
        partelope: [],
        partelope_id: "",
        is_padrao: this.vn_padrao,
        status: 1,
      });
    },
    removeRowTel: function (index) {
      this.pessoa_contato_tel.splice(index, 1);
    },
    addRowEmail: function (e) {
      e.preventDefault();
      this.vn_padrao = 1;
      if (this.pessoa_contato_email.length > 0) {
        this.vn_padrao = 2;
      }
      this.pessoa_contato_email.push({
        email: "",
        status: 1,
        email_default: "",
        partpema_id: "",
        email_default: this.vn_padrao,
        partpema: [],
      });
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    removeRowEmail: function (index) {
      this.pessoa_contato_email.splice(index, 1);
    },
    onReloadVuetable() {
      this.$refs.vuetable.reload();
    },
    onGerarCodigoCliente(pessoa_id) {
      this.helpForm.pessoa_id = pessoa_id;
      this.helpForm
        .post("/api/pessoa/codigo")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    listaFornecedor(search) {
      if (search.length >= 3) {
        this.isLoadingFornecedor = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/fornecedor")
          .then((response) => {
            this.optionsFornecedor = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                this.optionsFornecedor.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                this.optionsFornecedor.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsFornecedor.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            this.isLoadingFornecedor = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    ajustaMascaraForm(data) {
      if (data != null) {
        if (data.length == 11) {
          //cpf
          return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
        if (data.length == 14) {
          //cnpj
          return data.replace(
            /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/,
            "$1.$2.$3/$4-$5"
          );
        }
      }
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    getCep(index, origem) {
      //origem 1 = PessoaEndereco; origem 2 = PessoaReferencia
      if (origem == 1) {
        this.helpForm.cep_busca = this.pessoa_endereco[index].cep;
        this.array_cep = this.pessoa_endereco;
      } else {
        this.helpForm.cep_busca = this.pessoa_referencia[index].cep;
        this.array_cep = this.pessoa_referencia;
      }

      //Nova variável "cep" somente com dígitos.
      var cep = this.helpForm.cep_busca.replace(/\D/g, "");

      //Verifica se campo cep possui valor informado.
      if (cep != "") {
        //Expressão regular para validar o CEP.
        var validacep = /^[0-9]{8}$/;

        //Valida o formato do CEP.
        if (validacep.test(cep)) {
          this.loadingCep = true;
          this.helpForm
            .post("/api/cep/pesquisar")
            .then((response) => {
              new ReturnApi(response, this, true, false, false);

              this.helpForm.errors.clear();
              response.forEach((obj) => {
                this.array_cep[index].endereco = obj.logradouro;
                this.array_cep[index].bairro = obj.bairro;
                this.array_cep[index].complemento = obj.complemento;
                this.$parent.optionsMunicipio.forEach((obj2) => {
                  if (obj2.ibge == obj.ibge) {
                    this.array_cep[index].municipio = {
                      label: obj2.label,
                      value: obj2.value,
                    };
                  }
                });
              });
              this.loadingCep = false;
            })
            .catch((errors) => {
              this.loadingCep = false;
              new ReturnApi(errors, this);
            });
        } else {
          var errors = {
            errors: {
              emi_cep: ["Cep inválido"],
            },
          };
          this.helpForm.errors.record(errors.errors);
        }
      }
    },
    ajustaMascara() {
      if (this.form.tipo_pessoa == 1) {
        //PF
        this.mascaraDoc = "###.###.###-##";
      }
      if (this.form.tipo_pessoa == 2) {
        //PJ
        this.mascaraDoc = "NN.NNN.NNN/NNNN-NN";
      }
      if (this.form.tipo_pessoa == 3) {
        //PO
        this.mascaraDoc = "XXXXXXXXXXXXXXXX";
      }
    },
    formatDate(value, fmt = "DD MM YYYY") {
      return value == null ? "" : moment(value, "YYYY/MM/DD").format(fmt);
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .post("/api/" + this.rota + "/status")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    urlPlataformaLogistica() {
      return getPlataformaLogisticaUrl();
    },
    isFornecedorFieldLocked() {
      return (
        this.modal_acao !== "i" &&
        Number(this.form.fornecedor) === FORNECEDOR_SIM
      );
    },
    fornecedorFieldOptions() {
      const options = this.$parent.optionsLivFornecedor || [];

      return options.map((option) => {
        const isFornecedorSimOption = Number(option.value) === FORNECEDOR_SIM;
        const disabled = this.isFornecedorFieldLocked || isFornecedorSimOption;

        return {
          text: option.text,
          value: option.value,
          disabled,
          shouldShowMigrationTooltip: isFornecedorSimOption,
        };
      });
    },
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>